import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TableSortLabel,
  Popper,
  Collapse,
  ClickAwayListener,
  Divider,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  FormControl,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { ReactComponent as AddIcon } from "../../Assets/Icons/AddIcon.svg";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/SearchIcon.svg";
import { connect, useSelector } from "react-redux";
import {
  RESET_PATIENT_STATE,
  START_GET_PATIENT_LIST,
  START_DELETE_PATIENT,
  START_GET_PATIENT_NOTE_LIST,
  START_CREATE_PATIENT_NOTE,
  START_UPDATE_PATIENT_NOTE,
  START_DELETE_PATIENT_NOTE,
  START_GET_SINGLE_PATIENT_NOTE,
  START_GET_PATIENT_MEDICATION_HISTORY_LIST,
  START_STATUS_PATIENT_UPDATE,
  START_GET_SINGLE_PATIENT,
  START_ARCHIVE_MEDICATION,
  START_PATIENT_MULTI_DELETE,
  START_PATIENT_ALL_DELETE,
} from "../../Actions/PatientAction";
import { START_GET_PHARMACIES_LIST } from "../../Actions/PharmacyAction";
import { START_GET_REPEAT_ORDER_LIST } from "../../Actions/RepeatOrderAction";
import "../../Sass/Common.scss";
import { ReactComponent as ImportIcon } from "../../Assets/Icons/ImportIcon.svg";
import { ReactComponent as PersonIcon } from "Assets/Icons/user.svg";
import { ReactComponent as DuplicatePersonIcon } from "Assets/Icons/DuplicateIcon.svg";
import { ReactComponent as ContactSupportIcon } from "../../Assets/Icons/PharmsmartIcon/Howto.svg";
import { ReactComponent as AddPersonMainIcon } from "Assets/Icons/PharmsmartIcon/GroupIcon.svg";
import { useIntersection } from "../../Hooks/customHooks";
import _ from "underscore";
import { useNavigate } from "react-router-dom";
import {
  getClearObject,
  getLocalStorage,
  setLocalStorage,
  getNewOrder,
} from "../../utils/generalUtils";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import PatientTable from "./PatientTable";
import PatientOrderAndMediDialog from "./PatientOrderAndMediDialog";
import FilterListIcon from "@mui/icons-material/FilterList";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import InfomationDialog from "../../Components/RepeatOrder/InfomationDialog";
import Chips from "../../Components/Common/Chips";
import clsx from "clsx";
import { ReactComponent as SettingIcon } from "Assets/Icons/SettingsIcon.svg";
import TableColumnShowMenu from "../Common/Table/TableColumnShowMenu";
import { START_GET_HOME_LIST } from "../../Actions/HomeAction";
import PatientHistoryDialog from "../../Components/Patients/PatientHistoryDialog";
import HtmlTooltip from "../../Components/Common/HtmlTooltipMain";
import PatientDetailDialog from "./PatientDetailDialog";
import useViewport from "../../Hooks/useViewport";
import SubscriptionWaringDailog from "../../Components/Common/Dialog/SubscriptionWaringDailog";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MultipleOrderDialog from "./MultipleOrderDialog";
import { importType } from "../../utils/data";
import ImportCsvPatientDialog from "../../Components/ImportCsv/ImportCsvPatientDialog";
import MaxSelectDialog from "./MaxSelectDialog";
import ImportTypeDialog from "../../Components/ImportCsv/ImportTypeDialog";
import { ReactComponent as DeleteIcon } from "../../Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import { ReactComponent as RepeatorderIcon } from "../../Assets/Icons/PharmsmartIcon/ReapetOrder.svg";
import MultipleDeletePatient from "../../Components/Common/Dialog/MultipleDeletePatient";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
const EditDobDialog = React.lazy(() =>
  import("../../Components/Patients/EditDobDialog")
);
const ConfirmationDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/ConfirmationDialog")
);
const NotesDialog = React.lazy(() => import("Components/Patients/NotesDialog"));
// const PatientHistoryDialog = React.lazy(() =>
//   import("Components/Patients/PatientHistoryDialog")
// );
const useStyle = makeStyles((theme) => ({
  rsPatientHeader: {
    display: "flex",
    justifyContent: "end",
    width: "unset !important",

    "&>div": {
      "&>button": {
        height: "37px !important",
        marginLeft: "5px !important",
        marginRight: "5px !important",
        whiteSpace: "nowrap",
        [theme.breakpoints.down("475")]: {
          marginLeft: "0px",
        },
      },
    },
    "&>button": {
      whiteSpace: "nowrap",
      height: "37px !important",
      marginLeft: "5px !important",
      marginRight: "5px !important",
      [theme.breakpoints.down("475")]: {
        marginLeft: "0px",
      },
    },
    "&>div": {
      height: "37px !important",
      width: "auto",
      minWidth: "40px",
      marginLeft: "5px ",
      marginRight: "5px ",
      "&>div": {
        height: "37px !important",
      },
    },

    // [theme.breakpoints.down("1600")]: {
    //   display: "grid",
    //   gridTemplateColumns: "repeat(5, 1fr)",
    //   width: "min-content",
    //   "&>button": {
    //     width: "max-content",
    //     marginTop: "5px",
    //   },
    //   "&>div": {
    //     marginTop: "5px !important",
    //   },
    // },
    // [theme.breakpoints.down("1100")]: {
    //   display: "grid",
    //   gridTemplateColumns: "repeat(4, 1fr)",
    //   width: "min-content",
    //   "&>button": {
    //     width: "max-content",
    //     marginTop: "5px",
    //   },
    //   "&>div": {
    //     marginTop: "5px !important",
    //   },
    // },

    // [theme.breakpoints.down("930")]: {
    //   display: "grid",
    //   gridTemplateColumns: "repeat(3, 1fr)",
    //   width: "min-content",
    //   "&>button": {
    //     width: "max-content",
    //     marginTop: "5px",
    //   },
    //   "&>div": {
    //     marginTop: "5px !important",
    //   },
    // },
    [theme.breakpoints.down("1000")]: {
      justifyContent: "space-between",
      width: "100% !important",
    },
    [theme.breakpoints.down("660")]: {
      display: "flex !important",
      flexDirection: "row !important",
      width: "100%",
      "&>button": {
        width: "max-content",
        // marginTop: "5px",
      },
      "&>div": {
        // marginTop: "5px !important",
      },
    },

    // [theme.breakpoints.down("830")]: {
    //   paddingTop: "10px",
    // },
    // [theme.breakpoints.down("635")]: {
    // display: "flex",
    // "&>button": {
    //   marginTop: "10px",
    // },
    // "&>div": {
    //   marginTop: "10px",
    // },
    // },
    // [theme.breakpoints.down("475")]: {
    //   display: "grid",
    //   "&>button": {
    //     marginLeft: "0px",
    //     marginTop: "10px",
    //   },
    //   "&>div": {
    //     marginTop: "10px",
    //   },
    // },
    [theme.breakpoints.down("550")]: {
      "&>div": {
        marginBottom: "10px",
      },
    },
    [theme.breakpoints.down("410")]: {
      "&>button": {
        marginBottom: "10px",
        marginLeft: "10px !important",
        marginRight: "10px !important",
      },
    },
  },
  rsPatientHeadernotselect: {
    display: "flex",
    justifyContent: "end",
    "&>div": {
      "&>button": {
        height: "37px !important",
        marginLeft: "5px !important",
        marginRight: "5px !important",
        whiteSpace: "nowrap",
        [theme.breakpoints.down("475")]: {
          marginLeft: "0px",
        },
      },
    },
    "&>button": {
      whiteSpace: "nowrap",
      height: "37px !important",
      marginLeft: "5px !important",
      marginRight: "5px !important",
      [theme.breakpoints.down("475")]: {
        marginLeft: "0px",
      },
    },
    "&>div": {
      height: "37px !important",
      width: "216px",
      minWidth: "40px",
      marginLeft: "5px !important",
      marginRight: "5px !important",
      "&>div": {
        height: "37px !important",
      },
    },

    [theme.breakpoints.down("1300")]: {
      display: "grid",
      gridTemplateColumns: "repeat(5, 1fr)",
      width: "min-content",
      "&>button": {
        width: "max-content",
        marginTop: "5px",
      },
      "&>div": {
        marginTop: "5px !important",
      },
    },
    // [theme.breakpoints.down("1100")]: {
    //   display: "grid",
    //   gridTemplateColumns: "repeat(4, 1fr)",
    //   width: "min-content",
    //   "&>button": {
    //     width: "max-content",
    //     marginTop: "5px",
    //   },
    //   "&>div": {
    //     marginTop: "5px !important",
    //   },
    // },
    [theme.breakpoints.down("930")]: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      width: "min-content",
      "&>button": {
        width: "max-content",
        marginTop: "5px",
      },
      "&>div": {
        marginTop: "5px !important",
      },
    },
    [theme.breakpoints.down("660")]: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      width: "min-content",
      "&>button": {
        width: "max-content",
        marginTop: "5px",
      },
      "&>div": {
        marginTop: "5px !important",
      },
    },
    [theme.breakpoints.down("550")]: {
      display: "block",
      "&>div": {
        marginBottom: "10px",
      },
    },
    [theme.breakpoints.down("410")]: {
      "&>button": {
        marginBottom: "10px",

        marginLeft: "10px !important",
        marginRight: "10px !important",
      },
    },
  },
  tableHead: {
    "&>tr": {
      padding: "23px 18px !important",
      "&>th": {
        whiteSpace: "nowrap !important",
        // "&:first-child": {},
        " &:first-child": {
          width: "100px",
          [theme.breakpoints.down(1500)]: {
            width: "16%",
          },
          [theme.breakpoints.up("lg")]: {
            width: "36%",
          },
          [theme.breakpoints.up("xl")]: {
            width: "31%",
          },
        },
        "&:nth-child(2)": {
          width: "14%",
          [theme.breakpoints.down(1500)]: {
            width: "220px",
            padding: "2px -5px !important",
          },
          [theme.breakpoints.down(1400)]: {
            width: "17%",
          },
        },
        "&:nth-child(3)": {
          width: "20% !important",
        },
        "&:nth-child(4)": {
          width: "21% !important",
        },
        "&:nth-child(5)": {
          width: "16% !important",
          [theme.breakpoints.down(1400)]: {
            width: "8% !important",
          },
        },
        "&:last-child": {
          width: "1% !important",
          whiteSpace: "nowrap",
          padding: "0 30px !important",
        },
      },
    },
  },
  tableBody: {
    "&>tr": {
      "&>td": {
        "&:first-child": {
          //whiteSpace: "nowrap !important",
        },
        " &:nth-child(2)": {
          //whiteSpace: "nowrap !important",
        },
        " &:nth-child(3)": {
          // whiteSpace: "nowrap !important",
        },
        " &:nth-child(4)": {
          //whiteSpace: "nowrap !important",
        },
      },
    },
  },
  rsPatientFCount: {
    "&>div": {
      "&>button": {
        whiteSpace: "nowrap",
        height: "37px !important",

        marginLeft: "4px !important",
        marginRight: "10px !important",
      },
    },
    "&>button": {
      whiteSpace: "nowrap",
      height: "37px !important",
      marginLeft: "20px",

      marginLeft: "4px !important",
      marginRight: "10px !important",
    },
    [theme.breakpoints.down("635")]: {
      height: "auto",
    },
  },
  importBtn: {
    "&>span": {
      "&>svg": {
        "&>path": {
          fill: "white !important",
        },
      },
    },
  },
  rsPatientLeftHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: "6px 6px",
    background: "#333",
    display: "flex",
    justifyContent: "space-between",
    // [theme.breakpoints.down("1300")]: {
    //   display: "block",
    // },
    [theme.breakpoints.down("1000")]: {
      height: "95px",
      alignItems: "start",
    },
    [theme.breakpoints.between("680", "769")]: {
      height: "52px",
      alignItems: "start",
    },
    [theme.breakpoints.down("635")]: {
      display: "grid",
      "&>button": {
        width: "200px",
        marginLeft: "4px !important",
        marginRight: "10px !important",
      },
    },
  },
  rsIconFilterDispense: {
    // marginTop: "5px",
    top: "0px !important",
    "&>div": {
      "&>svg": {
        width: "20px",
        height: "20px",
      },
    },
  },
  rsCursor: {
    cursor: "pointer",
  },
  rsPopperPage: {
    zIndex: "6",
    padding: "7px 21px 9px",
    backgroundColor: "white",
    position: "absolute",
    marginTop: "10px !important",
    top: "8px !important",
    // left: "400px !important",
    borderRadius: "10px",
    width: "9%",
    boxShadow:
      "0px 8px 15px rgba(110, 117, 130, 0.15), 0px 1px 2px rgba(110, 117, 130, 0.3)",
    [theme.breakpoints.down(1300)]: {
      width: "15%",
    },
    [theme.breakpoints.down(1100)]: {
      width: "20%",
    },
    [theme.breakpoints.down(800)]: {
      width: "23%",
    },
    [theme.breakpoints.down(769)]: {
      top: "230px !important",
      // left: "200px !important",
    },
    [theme.breakpoints.down(600)]: {
      width: "180px",
      left: "180px !important",
    },
    [theme.breakpoints.down(550)]: {
      top: "280px !important",
      // left: "200px !important",
    },
    [theme.breakpoints.down(400)]: {
      top: "310px !important",
      // left: "200px !important",
    },
  },
  rsWaringFilterlistview: {
    "&>li": {
      display: "block",
      marginBottom: "10px",
      marginTop: "10px",
      "&>svg": {
        top: "5px",
        position: "relative",
      },
    },
  },
  rsDivider: {
    background: "#F7F7F8 !important",
    marginTop: "15px !important",
    marginBottom: "1px !important",
  },
  rsTableCellHeader: {
    display: "flex",
    alignItems: "center",
    height: "19px",
  },
  rsActiveBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "10px",
    width: "10px",
    borderRadius: "5px",
    position: "relative",
    marginTop: "8px",
    marginLeft: "5px",
    justifyContent: "flex-start !important",
  },
  rsListAlignment: {
    display: "flex",
    justifyContent: "space-between",
    "&>div": {
      display: "flex",
    },
  },
  rsiconBtn: {
    display: "flex",
    position: "relative",
  },
  managePageH: {
    "& .MuiTableContainer-root": {
      maxHeight: "calc(96vh - 148px) !important",
      padding: "0px !important",
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              // padding: "7px 16px",
              padding: "11px 16px",
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              "&:first-child": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: "0px",
                zIndex: 4,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "sticky",
                left: 0,
                zIndex: 3,
              },
              " &:nth-child(3)": {
                position: "sticky",
                left: 0,
                zIndex: 3,
              },
              " &:nth-child(4)": {
                position: "sticky",
                right: 0,
                zIndex: 3,
              },
              " &:nth-child(5)": {
                position: "sticky",
                right: 0,
                zIndex: 4,
                whiteSpace: "nowrap",
              },
              " &:nth-child(6)": {
                position: "sticky",
                right: 0,
                zIndex: 3,
              },
              " &:nth-child(7)": {
                position: "sticky",
                right: 0,
                zIndex: 3,
              },
              "&:last-child": {
                position: "sticky",
                right: "0px",
                padding: "0 16px !important",
                zIndex: 4,
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                left: "0px",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
              },
              " &:nth-child(3)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
              },
              " &:nth-child(4)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
              },
              " &:nth-child(5)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
                right: 0,
                //whiteSpace: "nowrap",
              },
              " &:nth-child(6)": {
                position: "sticky",
                right: "0",
                zIndex: 0,
                //whiteSpace: "nowrap",
              },
              " &:nth-child(7)": {
                position: "sticky",
                right: 0,
                zIndex: 2,
                //whiteSpace: "nowrap",
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  managePageHMob: {
    "& .MuiTableContainer-root": {
      padding: "0px !important",
      [theme.breakpoints.down("1200")]: {
        maxHeight: " !important",
      },
      [theme.breakpoints.down("1000")]: {
        maxHeight: "calc(100vh - 220px) !important",
      },
      [theme.breakpoints.down("769")]: {
        maxHeight: "calc(100vh - 185px) !important",
      },
      [theme.breakpoints.down("680")]: {
        maxHeight: "calc(100vh - 228px) !important",
      },
      [theme.breakpoints.down("600")]: {
        maxHeight: "calc(100vh - 220px) !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              padding: "11px 16px",
              "&:first-child": {
                whiteSpace: "nowrap",
                position: "sticky",

                zIndex: 4,
              },
              " &:nth-child(2)": {
                position: "sticky",
                borderLeft: "none !important",
                zIndex: 3,
              },
              " &:nth-child(3)": {
                position: "sticky",

                zIndex: 3,
              },
              " &:nth-child(4)": {
                position: "sticky",

                zIndex: 3,
              },
              " &:nth-child(5)": {
                position: "sticky",

                zIndex: 4,
                whiteSpace: "nowrap",
              },
              " &:nth-child(6)": {
                position: "sticky",

                zIndex: 3,
              },
              " &:nth-child(7)": {
                position: "sticky",

                zIndex: 3,
              },
              "&:last-child": {
                position: "sticky",

                padding: "0 10px !important",
                zIndex: 4,
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "relative",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                background: "#ffffff",
                position: "relative",
                zIndex: 1,
                borderLeft: "none !important",
              },
              " &:nth-child(3)": {
                background: "#ffffff",
                position: "relative",
                zIndex: 1,
              },
              " &:nth-child(4)": {
                background: "#ffffff",
                position: "relative",
                zIndex: 1,
              },
              " &:nth-child(5)": {
                background: "#ffffff",
                position: "relative",
                zIndex: 1,
                whiteSpace: "nowrap",
              },
              " &:nth-child(6)": {
                position: "relative",
                zIndex: 0,
                whiteSpace: "nowrap",
              },
              " &:nth-child(7)": {
                position: "relative",
                zIndex: 2,
                whiteSpace: "nowrap",
              },
              "&:last-child": {
                background: "#ffffff",
                position: "relative",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  rsActiveIconBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "8px",
    width: "8px",
    borderRadius: "5px",
    marginTop: "8px",
    marginLeft: "5px",
    position: "absolute",
    left: "12px",
    top: "3px",
  },
  globalSettingIcon: {},
  rsSetting: {
    paddingRight: "10px",
    [theme.breakpoints.down(769)]: {
      paddingRight: "18px !important",
    },
  },
  rsGrid: {
    [theme.breakpoints.down(769)]: {
      padding: "10px !important",
    },
  },
  rsSettingMain: {
    display: "flex",
    justifyContent: "end",
    [theme.breakpoints.down(475)]: {
      marginTop: "60px",
    },
  },
  rsMainMarign: {
    [theme.breakpoints.down(768)]: {
      marginTop: "0px !important",
    },
  },
  search: {
    marginTop: "0px !important",
  },
  buttonAddorder: {
    marginLeft: "5px !important",
    marginRight: "5px !important",
    "&>button": {
      height: "37px !important",
      fontSize: "13px !important",
      whiteSpace: "nowrap",
      marginLeft: "0px !important",
      marginRight: "0px !important",
    },
  },
  rsSelectMenulistProject: {
    position: "fixed !important",
    // marginLeft: "-154px !important",
    width: "47px !important",
    opacity: "0 !important",
    right: "230px",
    top: "110px",
    // [theme.breakpoints.down(1300)]: {
    //   left: "315px",
    //   top: "134px",
    // },
    // [theme.breakpoints.down(769)]: {
    //   left: "235px",
    //   top: "160px",
    // },
    // [theme.breakpoints.down(550)]: {
    //   left: "15px",
    //   top: "190px",
    // },
    // [theme.breakpoints.down(410)]: {
    //   left: "15px",
    //   top: "210px",
    // },
  },
  rsSelectMenulist: {
    position: "fixed !important",
    // marginLeft: "-154px !important",
    width: "47px !important",
    opacity: "0 !important",
    right: "230px",
    top: "110px",
    // [theme.breakpoints.down(1600)]: {
    //   right: "270px",
    // },
    // [theme.breakpoints.down(1300)]: {
    //   left: "680px",
    //   top: "134px",
    // },
    // [theme.breakpoints.down(1100)]: {
    //   left: "720px",
    //   top: "134px",
    // },
    // [theme.breakpoints.down(930)]: {
    //   left: "98px",
    //   top: "170px",
    // },
  },
  // customPopover: {
  //   height: "100px",
  // },
  // customBackdrop: {
  //   display: "none !important",
  //   "&>div": {
  //     display: "none !important",
  //   },
  // },
  MenuListDownload: {
    display: "flex",
    justifyContent: "center",
    "&>button": {
      borderColor: "#7BC044 !important",
      borderStyle: "solid !important",
      backgroundColor: "rgba(234, 251, 227, 1) !important",
      borderWidth: "2px !important",
      margin: "5px 10px !important",
      textAlign: "center !important",
      justifyContent: "center !important",
      width: "280px",

      marginLeft: "10px !important",
      marginRight: "10px !important",
    },
  },
  rsHowTo: {
    paddingRight: "10px",
    width: "40px !important",
    minWidth: "35px !important",
    marginLeft: "7px",
    // zIndex: "10000000",
    // zIndex: "1000",
    "&>button": {
      whiteSpace: "nowrap",
      height: "37px !important",
    },
  },
  rsButtonAddIcon: {
    background: "#e9514e !important",
    padding: "12px !important",
    borderRadius: "5px !important",
    "&>svg": {
      "&>path": {
        fill: "#e9514e !important",
        stroke: "white",
      },
    },
    "&:disabled": {
      background: "rgba(90, 104, 114,1) !important",
      "&>svg": {
        "&>path": {
          fill: "rgba(90, 104, 114,1) !important",
          stroke: "white",
        },
      },
    },
  },
  rsButtonOrderIcon: {
    background: "#7bc044 !important",
    padding: "12px !important",
    borderRadius: "5px !important",
    "&>svg": {
      "&>path": {
        fill: "white !important",
        // stroke: "white",
      },
    },
  },
  rsButtonHowtoIcon: {
    background: "#7bc044 !important",
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    "&>svg": {
      "&>path": {
        fill: "#7bc044 !important",
        stroke: "white",
      },
    },
  },
  rsCreateButton: {
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    "&>span": {
      marginLeft: "-8px",
    },
    "&>svg": {
      "&>path": {
        fill: "#7bc044 !important",
        stroke: "white",
      },
    },
  },
  rsButtonPatientsIcon: {
    background: "#7bc044 !important",
    // padding: "12px !important",
    borderRadius: "5px !important",

    "&>svg": {
      // fontSize: "30px !important",
      width: "24px",
      height: "24px",

      "&>g": {
        "&>path": {
          fill: "white !important",
          // stroke: "white",
        },
      },
    },
    "&>span": {
      "&>svg": {
        "&>path": {
          fill: "white !important",
          // stroke: "white",
        },
      },
    },
  },
  isExpandSearch: {
    transform: "unset",
    transition: "all 0.4s ease",
    // transition: "0.4s",
    cursor: "default !important",
    width: "200px !important",
    marginTop: "-7px !important",
    // marginBottom: "10px !important",
    marginRight: "8px !important",
    [theme.breakpoints.down("1000")]: {
      marginRight: "0px !important",
      marginBottom: "5px !important",
    },
    [theme.breakpoints.down("769")]: {
      marginRight: "8px !important",
      marginBottom: "0px !important",
      "&>div": {
        height: "37px !important",
      },
    },
    [theme.breakpoints.down("680")]: {
      marginRight: "0px !important",
      marginBottom: "5px !important",
      "&>div": {
        height: "37px !important",
      },
    },
    [theme.breakpoints.down("386")]: {
      width: "155px !important",
      marginRight: "0px !important",
      marginBottom: "5px !important",
      "&>div": {
        height: "37px !important",
      },
    },
    [theme.breakpoints.down("340")]: {
      width: "140px !important",
      marginRight: "0px !important",
      marginBottom: "5px !important",
      "&>div": {
        height: "37px !important",
      },
    },
    "&>div": {
      "&>div": {
        "&>input": {
          height: "37px !important",
        },
        "&>div": {
          marginRight: "-4px !important",
        },
      },
    },
  },
  textSearch: {
    // transform: "unset",
    // transition: "0.1s",
    // transition: "all 0.1s ease",
    cursor: "default !important",
    width: "40px !important",
    marginTop: "-10px !important",
    marginBottom: "10px !important",
    marginRight: "8px !important",
    "&>div": {
      "&>div": {
        paddingLeft: "10px !important",
        "&>div": {
          // marginLeft: "-18px",
        },
        "&>input": {
          padding: "0px 2px !important",
          width: "0px",
        },
      },
      "&>input": {
        padding: "0px  !important",
        width: "0px",
      },
    },
  },
  repeatordermultiple: {
    background: "#7bc044 !important",
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    marginRight: "5px",
    "&>svg": {
      fill: "#7bc044 !important",
      "&>path": {
        stroke: "white",
      },
    },
    "&>span": {
      color: "white !important",
      fontSize: "16px",
      fontWeight: "500 !important",
      paddingLeft: "6px !important",
    },
  },
  rsTable: {
    position: "relative",
    clear: "both",
    // marginTop: "5px"
  },
  filterHeadMobile: {
    display: "flex",
    flexDirection: "column",
    "&>div": {
      flexDirection: "row",
    },
  },
  resHeaderConatiner: {
    display: "flex",
    width: "100% !important",
    justifyContent: "space-between",
  },
  resHeaderButtons: {
    display: "flex",
    marginTop: "5px !important",
    "&>button:nth-child(1)": {
      height: "37px !important",
      marginLeft: "0px !important",
      marginRight: "5px !important",
      whiteSpace: "nowrap",
    },
    "&>button": {
      height: "37px !important",
      marginLeft: "5px !important",
      marginRight: "5px !important",
      whiteSpace: "nowrap",
    },
    "&>div": {
      marginLeft: "0px !important",
    },
  },
  resHeaderSearch: {
    display: "flex",
    flexDirection: "column !important",
    alignItems: "flex-end !important",
    [theme.breakpoints.down("769")]: {
      flexDirection: "row !important",
      alignItems: "start",
    },
    [theme.breakpoints.down("680")]: {
      flexDirection: "column !important",
      alignItems: "flex-end !important",
    },
  },
  resCreateButtonContainer: {
    [theme.breakpoints.down("340")]: {
      "&>button": {
        padding: "8px 15px !important",
      },
    },
  },
}));

/** head title */
const tableCells = {
  name: {
    id: "name",
    label: "NAME",
    sortable: true,
    icons: true,
    show: true,
    showValue: false,
  },
  dob: {
    id: "dob",
    label: "DOB",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
  },
  surgery_name: {
    id: "surgery_name",
    label: "SURGERY",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
  },
  pharmacy_name: {
    id: "pharmacy_name",
    label: "PHARMACY",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
  },
  scheduled: {
    id: "scheduled",
    label: "REPEAT ORDER",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
  },
  address: {
    id: "address",
    label: "ADDRESS",
    sortable: true,
    icons: false,
    show: false,
    showValue: true,
  },
  group: {
    id: "g_name",
    label: "GROUP",
    sortable: true,
    icons: false,
    show: false,
    showValue: true,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    icons: false,
    show: true,
    showValue: false,
  },
};

const tableCellsPharmacy = {
  name: {
    id: "name",
    label: "NAME",
    sortable: true,
    icons: true,
    show: true,
    showValue: false,
  },
  dob: {
    id: "dob",
    label: "DOB",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
  },
  surgery_name: {
    id: "surgery_name",
    label: "SURGERY",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
  },
  scheduled: {
    id: "scheduled",
    label: "REPEAT ORDER",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
  },
  address: {
    id: "address",
    label: "ADDRESS",
    sortable: true,
    icons: false,
    show: false,
    showValue: true,
  },
  group: {
    id: "g_name",
    label: "GROUP",
    sortable: true,
    icons: false,
    show: false,
    showValue: true,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    icons: false,
    show: true,
    showValue: false,
  },
};

const PatientsMain = (props) => {
  const {
    getPatientListAction,
    patientList,
    deletePatientAction,
    deletePatientData,
    resetPatientState,
    getPatientNoteListAction,
    patientNoteList,
    createPatientNoteAction,
    createPatientNoteData,
    updatePatientNoteAction,
    updatePatientNoteData,
    deletePatientNoteAction,
    deletePatientNoteData,
    getSinglePatientNoteAction,
    singlePatientNoteData,
    getPatientHistoryAction,
    patientMedicationHistoryList,
    getPatientStatusUpdatAction,
    getPharmacyListAction,
    getHomeListAction,
    getOrderListAction,
    getSinglePatientAction,
    singlePatientData,
    getMedicationArchiveAction,
    archiveMedi,
    getPatientMultipleDeleteAction,
    deleteMultipleAndSingleCsvData,
    getPatientAllDeletePatientAction,
    deleteAllPatientData,
  } = props;
  const navigate = useNavigate();
  const classes = useStyle();
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const [searchValue, setSearchValue] = useState(
    getLocalStorage("isPatientEdit") === "true"
      ? getLocalStorage("patientSearchValue") || ""
      : ""
  );
  const [showPatientNoteList, setShowPatientNoteList] = useState({});
  const [openPatientNoteList, setOpenPatientNoteList] = useState(false);
  const [deletePatient, setDeletePatient] = useState(false);
  const [patientDeleteId, setPatientDeleteId] = useState("");
  const [openPatientHistory, setOpenPatientHistory] = useState(false);
  const [patientHistory, setPatientHistory] = useState({});
  const [patientStatus, setPatientStatus] = useState("");
  const [filteredPatientId, setFilteredPatientId] = useState("");
  const [openOrderMediDialog, setOpenOrderMediDialog] = useState(false);
  const [patientDetailsId, setPatientDetailsId] = useState({});
  const [multipleOrder, setMultipleOrder] = useState(false);
  const [complianceStatus, setComplianceStatus] = useState(false);
  const [patientTypeStatus, setPatientTypeStatus] = useState([]);
  const [instalmentTypeStatus, setInstalmentTypeStatus] = useState([]);
  const [patientFilterTypeStatus, setPatientFilterTypeStatus] = useState([]);
  const [checked, setChecked] = React.useState(false);
  const [patientTypeOpen, setPatientTypeOpen] = useState(false);
  const [dispenseTypeOpen, setDispenseTypeOpen] = useState(false);
  const [statusTypeOpen, setStatusTypeOpen] = useState(false);
  const [statusManage, setStatusManage] = useState(false);
  const [statusApi, setStatusApi] = useState(false);
  const [patientActionType, setPatientActionType] = useState("");
  const [patientId, setPatientId] = useState("");
  const [patientDetailOpen, setPatientDetailOpen] = useState(false);
  const [isArchiveDetails, setIsArchiveDetails] = useState(false);
  const patientListRecordLimit = 20;
  const { headerSelectedPharmaciesFilter, loginUserDetail } = useSelector(
    (state) => state.user
  );
  const defaultColumnOrderBy = "asc";
  const [columnSortingOrder, setColumnSortingOrder] = useState({
    orderBy: "",
    sortBy: "",
  });
  const [columnsPopperAnchorEl, setColumnsPopperAnchorEl] = useState(null);
  const [detailsDialog, setDetailsDialog] = useState(false);
  const [isOpenEditDobModel, setIsOpenEditDobModel] = useState(false);
  const [editDobDate, setEditDobDate] = useState({});
  const [patientDetails, setPatientDetails] = useState({});
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const [orderCount, setOrderCount] = useState("");
  const [collectionCount, setCollectionCount] = useState("");
  const showDataBasedOnRole = getLocalStorage("role");
  const [openTableColumn, setOpenTableColumn] = useState(false);
  const [tableColumns, setTableColumns] = useState({});
  const [isArchive, setIsArchive] = useState(false);
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const [selected, setSelected] = React.useState([]);
  const [deletePatientmultiple, setDeletePatientmultiple] = useState(false);
  const [multipleOrderDialog, setMultipleOrderDialog] = useState(false);
  const [docLink, setDocLink] = useState("");
  const [importTypeDiloag, setImportTypeDiloag] = useState(false);
  const [openImportCsvPopup, setOpenImportCsvPopup] = useState(false);
  const [multipleDelete, setMultipleDelete] = useState("");
  const [multipleDeletePatient, setMultipleDeletePatient] = useState("");
  const [maxSelectDialog, setMaxSelectDialog] = useState(false);
  const [deleteAll, setDeleteAll] = useState(false);
  const [expand, setExpand] = useState(true);
  const [openSelect, setOpenSelect] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [isMouseOverButton, setIsMouseOverButton] = useState(false);
  const [isMouseOverSelect, setIsMouseOverSelect] = useState(false);

  const textFieldRef = useRef(null);
  const [popperAnchorEl, setPopperAnchorEl] = React.useState(null);
  const activeColumns =
    getLocalStorage("dynamicColumnPatient")?.split(",") || [];
  const columnSequence =
    getLocalStorage("dynamicColumnSequencePatient")?.split(",") || [];
  const showLoaderValue = Object.values(tableColumns).filter((item) => {
    return item;
  });
  const { width } = useViewport();
  /** Get patient api main function */
  const getList = (params = {}) => {
    let payload = {
      offset: 0,
      limit: patientListRecordLimit,
      q: searchValue,
      order_by: params.orderBy || columnSortingOrder.orderBy,
      sort_by: (params.sortBy || columnSortingOrder.sortBy).toUpperCase(),
    };

    if (selectedHeaderPharmacyId && selectedHeaderPharmacyId !== "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }

    if (complianceStatus == true) {
      payload.compliance_aid = true;
    }
    if (patientTypeStatus.length > 0) {
      payload.patient_type = patientTypeStatus;
    }
    if (instalmentTypeStatus.length > 0) {
      payload.instalment_type = instalmentTypeStatus;
    }
    if (patientFilterTypeStatus.length > 0) {
      payload.patient_status = patientFilterTypeStatus;
    }
    payload = {
      ...payload,
      ...params,
    };
    getPatientListAction(getClearObject(payload));
  };
  useEffect(() => {
    let payload = {
      offset: 0,
      limit: 20,
    };
    if (
      getLocalStorage("isPatientCreated") === "true" || (getLocalStorage("isPatientCancel") === "true" &&
        patientList?.data?.list?.length > 0) || (getLocalStorage("isPatientEdit") === "true" &&
          patientList?.data?.list?.length > 0)
    ) {
      setSearchValue(getLocalStorage("patientSearchValue") || "");
      setLocalStorage("isPatientCancel", "false");
      setLocalStorage("isPatientCreated", "false");
      setLocalStorage("isPatientEdit", "false");
      return;
    }
    setLocalStorage("isPatientCancel", "false");
    setLocalStorage("isPatientCreated", "false");
    setLocalStorage("isPatientEdit", "false");
    setLocalStorage("patientSearchValue", "");
    if (
      getLocalStorage("urlpatient") == "patients" &&
      selectedHeaderPharmacyId === "all"
    ) {
      getPatientListAction(payload);
      setLocalStorage("urlpatient", "none");
    } else {
      getPatientListAction(payload);
    }
    return () => {
      if (window.location.pathname !== "/patients") {
        // getPatientListAction(payload);
        // window.onbeforeunload = null;
        // setLocalStorage("pharmacyChange", false);
      }
    };
  }, []);

  /** Header pharmacy selection useEffect */
  useEffect(() => {
    let payLoad = {};
    if (!patientList?.loading) {
      if (
        // selectedHeaderPharmacyId !== "" ||
        selectedHeaderPharmacyId !== "all" ||
        getLocalStorage("pharmacyChange") == "true" ||
        checked === true
      ) {
        if (
          getLocalStorage("pharmacyChange") == "true" ||
          // selectedHeaderPharmacyId === "" ||
          selectedHeaderPharmacyId === "all"
        ) {
          let payload = {};
          getList(payload);
        } else {
          payLoad = {
            pharmacy_id: [selectedHeaderPharmacyId],
          };
          getList(payLoad);
        }
      }
      // if (selectedHeaderPharmacyId !== "") {
      //   payLoad = {
      //     pharmacy_id: [selectedHeaderPharmacyId],
      //   };
      //   getList(payLoad);
      // } else if (getLocalStorage("pharmacyChange") == "true") {
      //   getList(payLoad);
      // }
      // if (checked === true) {
      //   getList(payLoad);
      // }
      // getList(payLoad);
    }
  }, [
    selectedHeaderPharmacyId,
    complianceStatus,
    patientTypeStatus,
    instalmentTypeStatus,
    patientFilterTypeStatus,
  ]);

  /** Pagination useeffect */
  useEffect(() => {
    if (entry.isIntersecting) {
      if (
        patientList?.data?.list?.length != patientList?.data?.filterd_record
      ) {
        getList({
          offset: patientList?.data?.list?.length,
          limit: patientListRecordLimit,
          order_by: columnSortingOrder.orderBy,
          sort_by: columnSortingOrder.sortBy.toUpperCase(),
        });
      }
    }
  }, [entry]);

  /** Persist search value so it can be restored after returning from edit page */
  useEffect(() => {
    setLocalStorage("patientSearchValue", searchValue);
  }, [searchValue]);

  /** Search debounce useref */
  const searchUserDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      getList({
        ...(searchString && {
          q: searchString,
        }),
        ...otherStateValues,
      });
    }, 500)
  );

  /** Handle Search Funcation */
  const handleSearch = (newValue) => {
    let payLoad = {};
    if (complianceStatus === true) {
      payLoad.compliance_aid = true;
    }
    if (patientTypeStatus.length > 0) {
      payLoad.patient_type = patientTypeStatus;
    }
    if (instalmentTypeStatus.length > 0) {
      payLoad.instalment_type = instalmentTypeStatus;
    }
    if (patientFilterTypeStatus.length > 0) {
      payLoad.patient_status = patientFilterTypeStatus;
    }
    searchUserDebounce.current(newValue, {
      pharmacy_id:
        selectedHeaderPharmacyId !== "all" ? [selectedHeaderPharmacyId] : [],
      order_by: columnSortingOrder.orderBy,
      sort_by: columnSortingOrder.sortBy.toUpperCase(),
      patient_status: patientFilterTypeStatus,
      instalment_type: instalmentTypeStatus,
      patient_type: patientTypeStatus,
      compliance_aid: complianceStatus,
    });
  };

  /** Delete Patient Funcation */
  const handleDeletePatient = () => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    let payload = {
      offset: 0,
    };
    let payLoad = {};
    deletePatientAction(patientDeleteId);
    getPharmacyListAction(payload);
    // getHomeListAction(payLoad);
    // }
  };

  /** Delete Pateint loading useeffect */
  useEffect(() => {
    if (
      !deletePatientData?.loading &&
      Object.keys(deletePatientData?.data)?.length
    ) {
      setDeletePatient(false);
      setPatientDeleteId("");
      resetPatientState("deletePatientData", "");
      // getHomeListAction();
    }
  }, [deletePatientData]);

  /**   Detect column order changes */
  useEffect(() => {
    if (columnSortingOrder.orderBy && columnSortingOrder.sortBy) {
      getList();
    }
  }, [columnSortingOrder.orderBy, columnSortingOrder.sortBy]);

  useEffect(() => {
    if (patientStatus === "Active") {
      if (patientDetailsId.order_count !== 0) {
        if (patientDetailsId.order_count > 1) {
          setMultipleOrder(true);
        } else {
          setOpenOrderMediDialog(true);
        }
      }
    }
  }, [patientStatus]);

  useEffect(() => {
    if (statusApi === true) {
      let params = {
        status: "active",
      };
      getPatientStatusUpdatAction(patientDetailsId?.id, params);
    }
  }, [statusApi]);
  /**applied filter in the icon  */
  const handleIconFilterChange = (e) => {
    setPopperAnchorEl(e.currentTarget);
    setChecked((prev) => !prev);
  };
  /**handle click Away in filter dropdown */
  const handleClickAway = () => {
    setChecked(false);
  };

  const handleClickAwaySearch = () => {
    if (searchValue == "") {
      setExpand(false);
    }
  };

  const manageDispenseFilter = (newValue, type) => {
    if ("dispense" == type) {
      if (instalmentTypeStatus.includes(newValue)) {
        let tempData = instalmentTypeStatus.filter((item) => item != newValue);
        setInstalmentTypeStatus(tempData);
      } else {
        setInstalmentTypeStatus([...instalmentTypeStatus, newValue]);
      }
    }
    if ("patient" == type) {
      if (patientTypeStatus.includes(newValue)) {
        let tempData = patientTypeStatus.filter((item) => item != newValue);
        setPatientTypeStatus(tempData);
      } else {
        setPatientTypeStatus([...patientTypeStatus, newValue]);
      }
    }
    if ("status" === type) {
      if (patientFilterTypeStatus.includes(newValue)) {
        let tempData = patientFilterTypeStatus.filter(
          (item) => item != newValue
        );
        setPatientFilterTypeStatus(tempData);
      } else {
        setPatientFilterTypeStatus([...patientFilterTypeStatus, newValue]);
      }
    }
  };
  const handleType = (type) => {
    if (type === "patient") {
      setPatientTypeOpen(!patientTypeOpen);
    }
    if (type === "dispense") {
      setDispenseTypeOpen(!dispenseTypeOpen);
    }
    if (type === "status") {
      setStatusTypeOpen(!statusTypeOpen);
    }
  };

  //Set value after page refresh useEffect
  useLayoutEffect(() => {
    let allColumns =
      ["pharmacist_staff", "pharmacy"].indexOf(showDataBasedOnRole) !== -1
        ? tableCellsPharmacy
        : tableCells;

    if (activeColumns.length > 0) {
      Object.keys(allColumns)?.map((key) => {
        if (allColumns[key].showValue) {
          if (activeColumns.indexOf(allColumns[key].id) !== -1) {
            allColumns[key].show = true;
          } else {
            allColumns[key].show = false;
          }
        }
      });
    }
    allColumns = getNewOrder(columnSequence, allColumns);
    setTableColumns(allColumns);
  }, []);

  const handleMediArchive = (id, from) => {
    if (from === "history") {
      let historyPayload = { offset: 0, limit: 20 };
      getMedicationArchiveAction(id, patientHistory, historyPayload);
      setIsArchive(true);
    } else {
      let historyPayload = { offset: 0, limit: 20 };
      getMedicationArchiveAction(id, patientHistory, historyPayload);
      setIsArchiveDetails(true);
    }
  };
  useEffect(() => {
    if (archiveMedi?.data?.success) {
      if (isArchiveDetails) {
        getPatientHistoryAction(patientId, {
          offset: 0,
          limit: 20,
        });
        setIsArchiveDetails(false);
      }
    }
  }, [archiveMedi?.data?.success]);
  useEffect(() => {
    if (archiveMedi?.data?.success && isArchive) {
      getPatientHistoryAction(patientHistory, {
        offset: 0,
        limit: 20,
      });
      setIsArchive(false);
    }
  }, [archiveMedi?.data?.success]);

  /* Multiple Handle Change Action */
  const handleChangeAction = (e) => {
    if (e.target.checked) {
      const newSelected = patientList?.data?.list.map((item) => {
        return item;
      });
      if (newSelected?.length > 100) {
        setMaxSelectDialog(true);
      } else {
        setSelected(newSelected);
        return;
      }
    } else {
      setSelected([]);
    }
  };

  const handleClickTickAction = (event, item) => {
    if (selected?.length < 100) {
      const selectedIndex = selected.indexOf(item);
      let newSelected = [];
      //If record not found then add
      let openModals = false;
      if (selectedIndex === -1) {
        openModals = true;
        newSelected = newSelected.concat(selected, item);
        //If record present then remove
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }

      setSelected(newSelected);
    } else {
      setMaxSelectDialog(true);
    }
  };
  useEffect(() => {
    // deleteMultipleAndSingleCsvData
    if (!deleteMultipleAndSingleCsvData?.loading) {
      if (deleteMultipleAndSingleCsvData?.data?.success) {
        getList();
        setDeletePatientmultiple(false);
        setDeleteAll(false);
      }
    }
  }, [deleteMultipleAndSingleCsvData]);
  const handleDeleteMultipleList = () => {
    let temp = [];
    let haveorder = [];
    selected?.map((item) => {
      if (item?.order_count > 0) {
        haveorder.push(item);
      } else {
        temp.push(item?.id);
      }
    });
    let payload = {
      id: temp,
      // is_delete_all: selected?.length === importCsvListData?.data?.list?.length,
    };
    getPatientMultipleDeleteAction(payload);
    // deleteCsvAction(payload);
  };

  const handleDeleteAllPatient = () => {
    let payload = {
      delete_all: true,
    };
    getPatientMultipleDeleteAction(payload);
  };
  /* Download csv demo file */
  const downloadPDF = () => {
    var FileSaver = require("file-saver");
    FileSaver.saveAs(
      process.env.PUBLIC_URL + "/patients_new.csv",
      "patients.csv"
    );
  };
  const downloadPDFRX = () => {
    var FileSaver = require("file-saver");
    FileSaver.saveAs(
      process.env.PUBLIC_URL + "/RxWeb_fileAImport.xlsx",
      "rxweb1.xlsx"
    );
    FileSaver.saveAs(
      process.env.PUBLIC_URL + "/RxWeb_fileBImport.xlsx",
      "rxweb2.xlsx"
    );
  };
  const downloadPDFProscript = () => {
    var FileSaver = require("file-saver");
    FileSaver.saveAs(
      process.env.PUBLIC_URL + "/ProscriptImport.xlsx",
      "Proscripts.xlsx"
    );
  };
  const downloadPDFMPS = () => {
    var FileSaver = require("file-saver");
    FileSaver.saveAs(process.env.PUBLIC_URL + "/MPSImport.xlsx", "mps.xlsx");
  };
  const downloadPDFTitan = () => {
    var FileSaver = require("file-saver");
    FileSaver.saveAs(
      process.env.PUBLIC_URL + "/TitanfileA.xlsx",
      "Titan1.xlsx"
    );
    FileSaver.saveAs(
      process.env.PUBLIC_URL + "/TitanfileB.xlsx",
      "Titan2.xlsx"
    );
  };

  return (
    <>
      <Grid className={classes.rsMainMarign}>
        <Grid className={classes.rsPatientFCount}>
          <Grid className={classes.rsPatientLeftHeader} container>
            {width >= 1000 && (
              <HtmlTooltipMain title="" className="hoverAlign">
                {/* <IconButton
             className={classes.rsButtonHowtoIcon}
             variant="contained"
             // disabled={selected?.length > 0 ? true : false}
             onClick={() => {
               navigate("/patients?actionType=create");
               // getList();
               let payload = {
                 offset: 0,
                 limit: patientListRecordLimit,
                 // q: searchValue,
                 order_by: columnSortingOrder.orderBy,
                 sort_by: columnSortingOrder.sortBy.toUpperCase(),
               };

               if (selectedHeaderPharmacyId !== "all") {
                 payload.pharmacy_id = [selectedHeaderPharmacyId];
               }
               getPatientListAction(getClearObject(payload));
             }}
             startIcon={
               <PrimaryIcon
                 color="white "
                 icon={ImportIcon}
                 // color="primary"
                 width="16px"
                 height="16px"
               />
             }
           >
             <PrimaryIcon
               width="20px"
               icon={AddPersonMainIcon}
               cursor="pointer"
             />
           </IconButton> */}
                <Button
                  className={classes.rsCreateButton}
                  variant="contained"
                  startIcon={
                    <PrimaryIcon
                      icon={AddIcon}
                      color="white"
                      width="16px"
                      height="16px"
                    />
                  }
                  onClick={() => {
                    navigate("/patients?actionType=create");
                    // getList();
                    let payload = {
                      offset: 0,
                      limit: patientListRecordLimit,
                      // q: searchValue,
                      order_by: columnSortingOrder.orderBy,
                      sort_by: columnSortingOrder.sortBy.toUpperCase(),
                    };

                    if (selectedHeaderPharmacyId !== "all") {
                      payload.pharmacy_id = [selectedHeaderPharmacyId];
                    }
                    getPatientListAction(getClearObject(payload));
                    setLocalStorage("patientSearchValue", "");
                  }}
                >
                  Create Patient
                </Button>
              </HtmlTooltipMain>
            )}

            <Grid className={classes.rsPatientHeader} container>
              {width >= 1000 && (
                <>
                  <Box
                    className={
                      expand ? classes.isExpandSearch : classes.textSearch
                    }
                  >
                    {/* <ClickAwayListener onClickAway={handleClickAwaySearch}> */}
                    <TextField
                      inputRef={textFieldRef}
                      withPadding={true}
                      medium
                      secondary
                      placeholder="Search..."
                      value={searchValue}
                      onClick={() => {
                        if (textFieldRef.current) {
                          textFieldRef.current.focus();
                        }
                        setExpand(true);
                      }}
                      onChange={(e) => {
                        setSearchValue(e?.target?.value);
                        handleSearch(e?.target?.value);
                      }}
                      InputProps={{
                        endAdornment: (
                          <>
                            <InputAdornment
                              position="end"
                              onClick={() => {
                                if (textFieldRef.current) {
                                  textFieldRef.current.focus();
                                }
                                setExpand(true);
                              }}
                            >
                              <PrimaryIcon
                                width="20px"
                                icon={SearchIcon}
                                onClick={() => {
                                  if (textFieldRef.current) {
                                    textFieldRef.current.focus();
                                  }
                                  setExpand(true);
                                }}
                              />
                            </InputAdornment>
                          </>
                        ),
                      }}
                    />
                    {/* </ClickAwayListener> */}
                  </Box>
                  <HtmlTooltipMain
                    title="Delete All Patients"
                    className="hoverAlign"
                  >
                    <IconButton
                      className={classes.rsButtonAddIcon}
                      variant="contained"
                      disabled={selected?.length > 0 ? true : false}
                      onClick={() => {
                        setDeleteAll(true);
                      }}
                    >
                      <PrimaryIcon
                        width="20px"
                        icon={DeleteIcon}
                        cursor="pointer"
                      />
                    </IconButton>
                  </HtmlTooltipMain>

                  <HtmlTooltipMain
                    title="How To Import"
                    className="hoverAlign"
                    open={openTooltip}
                    // onOpen={() => setOpenTooltip(true)}
                    // onClose={() => setOpenTooltip(false)}
                  >
                    <Box className={classes.rsHowTo}>
                      <IconButton
                        className={classes.rsButtonHowtoIcon}
                        variant="contained"
                        // disabled={selected?.length > 0 ? true : false}
                        // onClick={() => {
                        // setDeleteAll(true);
                        // }}
                        onClick={() => {
                          // setOpenSelect(!openSelect);
                        }}
                      >
                        <PrimaryIcon
                          width="20px"
                          icon={ContactSupportIcon}
                          cursor="pointer"
                        />
                      </IconButton>
                      <Select
                        open={openSelect}
                        onOpen={() => {
                          setOpenSelect(true);
                          setOpenTooltip(false);
                        }}
                        onClose={() => {
                          setOpenSelect(false);
                          setOpenTooltip(false);
                        }}
                        onMouseLeave={() => {
                          setOpenTooltip(false);
                          setIsMouseOverButton(false);
                        }}
                        onMouseEnter={() => {
                          setOpenTooltip(true);
                          setIsMouseOverButton(true);
                        }}
                        className={
                          selected?.length > 0
                            ? classes.rsSelectMenulist
                            : classes.rsSelectMenulistProject
                        }
                        hideBackdrop={true}
                        MenuProps={{
                          disableScrollLock: true,
                          BackdropProps: {
                            className: classes.customBackdrop,
                          },
                          PaperProps: {
                            style: {
                              padding: "0px",
                              // maxHeight: ITEM_HEIGHT * 4.5,
                              // width: "32ch",
                              marginTop: "10px",
                            },
                          },
                        }}
                      >
                        {importType.map((name) => (
                          <MenuItem
                            hideBackdrop={true}
                            key={name.value}
                            value={name.label}
                            onClick={(e, value) => {
                              setDocLink(name?.link);
                              setImportTypeDiloag(true);
                            }}
                          >
                            {name?.label}
                          </MenuItem>
                        ))}
                        {/* <Box
                          className={classes.MenuListDownload}
                          // onClick={() => {
                          //   downloadPDF();
                          // }}
                        >
                          <Button
                            // className={classes.MenuListDownload}
                            variant="outlined"
                            onClick={() => {
                              downloadPDFProscript();
                            }}
                          >
                            Download Demo Proscript
                          </Button>
                        </Box>
                        <Box
                          className={classes.MenuListDownload}
                          // onClick={() => {
                          //   downloadPDF();
                          // }}
                        >
                          <Button
                            // className={classes.MenuListDownload}
                            variant="outlined"
                            onClick={() => {
                              downloadPDFRX();
                            }}
                          >
                            Download Demo RxWeb
                          </Button>
                        </Box>
                        <Box
                          className={classes.MenuListDownload}
                          // onClick={() => {
                          //   downloadPDF();
                          // }}
                        >
                          <Button
                            // className={classes.MenuListDownload}
                            variant="outlined"
                            onClick={() => {
                              downloadPDFTitan();
                            }}
                          >
                            Download Demo Titan
                          </Button>
                        </Box>
                        <Box
                          className={classes.MenuListDownload}
                          // onClick={() => {
                          //   downloadPDF();
                          // }}
                        >
                          <Button
                            // className={classes.MenuListDownload}
                            variant="outlined"
                            onClick={() => {
                              downloadPDFMPS();
                            }}
                          >
                            Download Demo MPS
                          </Button>
                        </Box> */}
                      </Select>
                    </Box>
                  </HtmlTooltipMain>

                  <HtmlTooltipMain
                    title=" Import Patient"
                    className="hoverAlign"
                  >
                    <IconButton
                      className={classes.rsButtonOrderIcon}
                      // className={classes.importBtn}
                      variant="outlined"
                      // className="btn_green"
                      onClick={() => {
                        setOpenImportCsvPopup(true);
                        // navigate(`/patients?actionType=import-patient`);
                      }}
                    >
                      <PrimaryIcon
                        color="white !important"
                        icon={ImportIcon}
                        // color="primary"
                        width="16px"
                        height="16px"
                      />
                    </IconButton>
                  </HtmlTooltipMain>

                  {selected?.length > 0 && (
                    <HtmlTooltip
                      title={
                        selected?.length === 0
                          ? "Select one or more patients to add repeat orders"
                          : selected?.length > 100
                          ? "Select less then 100 patients to add repeat orders"
                          : ""
                      }
                    >
                      <Box className={classes.buttonAddorder}>
                        {" "}
                        <HtmlTooltip title={"Add Repeat Orders"}>
                          <IconButton
                            // variant="outlined"
                            className={classes.repeatordermultiple}
                            disabled={
                              selected?.length === 0 ||
                              patientList?.data?.list?.length === 0
                            }
                            onClick={() => {
                              if (
                                selected?.length > 0 &&
                                selected?.length <= 100
                              ) {
                                setMultipleOrderDialog(true);
                              } else if (selected?.length > 100) {
                                setMaxSelectDialog(true);
                              }
                            }}
                          >
                            <PrimaryIcon
                              width="20px"
                              icon={RepeatorderIcon}
                              cursor="pointer"
                              color="#7bbd4b"
                            />

                            {/* Add Repeat Orders */}
                            <span>
                              {selected?.length > 0
                                ? `${selected?.length}`
                                : ""}
                            </span>
                          </IconButton>
                        </HtmlTooltip>
                      </Box>
                    </HtmlTooltip>
                  )}
                  <Box
                    className="ColumnMain"
                    onClick={(e) => {
                      setColumnsPopperAnchorEl(e.currentTarget);
                      if (
                        ["pharmacist_staff", "pharmacy"].indexOf(
                          showDataBasedOnRole
                        ) !== -1
                      ) {
                        setPatientActionType("patientPharmacyDetails");
                      } else {
                        setPatientActionType("patientDetails");
                      }
                      setOpenTableColumn(true);
                    }}
                  >
                    <HtmlTooltip title="Columns">
                      <Box>
                        <Button
                          className="ColumnBtn"
                          // onClick={() => {
                          //   if (
                          //     ["pharmacist_staff", "pharmacy"].indexOf(
                          //       showDataBasedOnRole
                          //     ) !== -1
                          //   ) {
                          //     setPatientActionType("patientPharmacyDetails");
                          //   } else {
                          //     setPatientActionType("patientDetails");
                          //   }
                          //   setOpenTableColumn(true);
                          // }}
                        >
                          <PrimaryIcon
                            color="black"
                            width="20px"
                            icon={ViewWeekIcon}
                            cursor="pointer"
                          />
                          Columns
                          <PrimaryIcon
                            color="black"
                            width="30px"
                            icon={ArrowDropDownIcon}
                            cursor="pointer"
                          />
                        </Button>
                      </Box>
                    </HtmlTooltip>
                  </Box>
                </>
              )}

              {width < 1000 && (
                <Grid className={classes.resHeaderConatiner}>
                  <Grid>
                    {/* Create patient */}

                    <Grid className={classes.resCreateButtonContainer}>
                      <HtmlTooltipMain title="" className="hoverAlign">
                        <Button
                          className={classes.rsCreateButton}
                          variant="contained"
                          startIcon={
                            <PrimaryIcon
                              icon={AddIcon}
                              color="white"
                              width="16px"
                              height="16px"
                            />
                          }
                          onClick={() => {
                            navigate("/patients?actionType=create");
                            // getList();
                            let payload = {
                              offset: 0,
                              limit: patientListRecordLimit,
                              // q: searchValue,
                              order_by: columnSortingOrder.orderBy,
                              sort_by: columnSortingOrder.sortBy.toUpperCase(),
                            };

                            if (selectedHeaderPharmacyId !== "all") {
                              payload.pharmacy_id = [selectedHeaderPharmacyId];
                            }
                            getPatientListAction(getClearObject(payload));
                          }}
                        >
                          Create Patient
                        </Button>
                      </HtmlTooltipMain>
                    </Grid>

                    {/* Other Buttons */}

                    {(width > 768 || width < 680) && (
                      <Grid className={classes.resHeaderButtons}>
                        <HtmlTooltipMain
                          title="Delete All Patients"
                          className="hoverAlign"
                        >
                          <IconButton
                            className={classes.rsButtonAddIcon}
                            variant="contained"
                            disabled={selected?.length > 0 ? true : false}
                            onClick={() => {
                              setDeleteAll(true);
                            }}
                          >
                            <PrimaryIcon
                              width="20px"
                              icon={DeleteIcon}
                              cursor="pointer"
                            />
                          </IconButton>
                        </HtmlTooltipMain>
                        <HtmlTooltipMain
                          title="How To Import"
                          className="hoverAlign"
                          open={openTooltip}
                          // onOpen={() => setOpenTooltip(true)}
                          // onClose={() => setOpenTooltip(false)}
                        >
                          <Box className={classes.rsHowTo}>
                            <IconButton
                              className={classes.rsButtonHowtoIcon}
                              variant="contained"
                              // disabled={selected?.length > 0 ? true : false}
                              // onClick={() => {
                              // setDeleteAll(true);
                              // }}
                              onClick={() => {
                                // setOpenSelect(!openSelect);
                              }}
                            >
                              <PrimaryIcon
                                width="20px"
                                icon={ContactSupportIcon}
                                cursor="pointer"
                              />
                            </IconButton>
                            <Select
                              open={openSelect}
                              onOpen={() => {
                                setOpenSelect(true);
                                setOpenTooltip(false);
                              }}
                              onClose={() => {
                                setOpenSelect(false);
                                setOpenTooltip(false);
                              }}
                              onMouseLeave={() => {
                                setOpenTooltip(false);
                                setIsMouseOverButton(false);
                              }}
                              onMouseEnter={() => {
                                setOpenTooltip(true);
                                setIsMouseOverButton(true);
                              }}
                              className={
                                selected?.length > 0
                                  ? classes.rsSelectMenulist
                                  : classes.rsSelectMenulistProject
                              }
                              hideBackdrop={true}
                              MenuProps={{
                                disableScrollLock: true,
                                BackdropProps: {
                                  className: classes.customBackdrop,
                                },
                                PaperProps: {
                                  style: {
                                    padding: "0px",
                                    // maxHeight: ITEM_HEIGHT * 4.5,
                                    // width: "32ch",
                                    marginTop: "10px",
                                  },
                                },
                              }}
                            >
                              {importType.map((name) => (
                                <MenuItem
                                  hideBackdrop={true}
                                  key={name.value}
                                  value={name.label}
                                  onClick={(e, value) => {
                                    setDocLink(name?.link);
                                    setImportTypeDiloag(true);
                                  }}
                                >
                                  {name?.label}
                                </MenuItem>
                              ))}
                              <Box
                                className={classes.MenuListDownload}
                                // onClick={() => {
                                //   downloadPDF();
                                // }}
                              >
                                <Button
                                  // className={classes.MenuListDownload}
                                  variant="outlined"
                                  onClick={() => {
                                    downloadPDFProscript();
                                  }}
                                >
                                  Download Demo Proscript
                                </Button>
                              </Box>
                              <Box
                                className={classes.MenuListDownload}
                                // onClick={() => {
                                //   downloadPDF();
                                // }}
                              >
                                <Button
                                  // className={classes.MenuListDownload}
                                  variant="outlined"
                                  onClick={() => {
                                    downloadPDFRX();
                                  }}
                                >
                                  Download Demo RxWeb
                                </Button>
                              </Box>
                              <Box
                                className={classes.MenuListDownload}
                                // onClick={() => {
                                //   downloadPDF();
                                // }}
                              >
                                <Button
                                  // className={classes.MenuListDownload}
                                  variant="outlined"
                                  onClick={() => {
                                    downloadPDFTitan();
                                  }}
                                >
                                  Download Demo Titan
                                </Button>
                              </Box>
                              <Box
                                className={classes.MenuListDownload}
                                // onClick={() => {
                                //   downloadPDF();
                                // }}
                              >
                                <Button
                                  // className={classes.MenuListDownload}
                                  variant="outlined"
                                  onClick={() => {
                                    downloadPDFMPS();
                                  }}
                                >
                                  Download Demo MPS
                                </Button>
                              </Box>
                            </Select>
                          </Box>
                        </HtmlTooltipMain>
                        <HtmlTooltipMain
                          title=" Import Patient"
                          className="hoverAlign"
                        >
                          <IconButton
                            className={classes.rsButtonOrderIcon}
                            // className={classes.importBtn}
                            variant="outlined"
                            // className="btn_green"
                            onClick={() => {
                              setOpenImportCsvPopup(true);
                              // navigate(`/patients?actionType=import-patient`);
                            }}
                          >
                            <PrimaryIcon
                              color="white !important"
                              icon={ImportIcon}
                              // color="primary"
                              width="16px"
                              height="16px"
                            />
                          </IconButton>
                        </HtmlTooltipMain>

                        {selected?.length > 0 && (
                          <HtmlTooltip
                            title={
                              selected?.length === 0
                                ? "Select one or more patients to add repeat orders"
                                : selected?.length > 100
                                ? "Select less then 100 patients to add repeat orders"
                                : ""
                            }
                          >
                            <Box className={classes.buttonAddorder}>
                              {" "}
                              <HtmlTooltip title={"Add Repeat Orders"}>
                                <IconButton
                                  // variant="outlined"
                                  className={classes.repeatordermultiple}
                                  disabled={
                                    selected?.length === 0 ||
                                    patientList?.data?.list?.length === 0
                                  }
                                  onClick={() => {
                                    if (
                                      selected?.length > 0 &&
                                      selected?.length <= 100
                                    ) {
                                      setMultipleOrderDialog(true);
                                    } else if (selected?.length > 100) {
                                      setMaxSelectDialog(true);
                                    }
                                  }}
                                >
                                  <PrimaryIcon
                                    width="20px"
                                    icon={RepeatorderIcon}
                                    cursor="pointer"
                                    color="#7bbd4b"
                                  />

                                  {/* Add Repeat Orders */}
                                  <span>
                                    {selected?.length > 0
                                      ? `${selected?.length}`
                                      : ""}
                                  </span>
                                </IconButton>
                              </HtmlTooltip>
                            </Box>
                          </HtmlTooltip>
                        )}
                      </Grid>
                    )}
                  </Grid>

                  <Grid className={classes.resHeaderSearch}>
                    <Box
                      className={
                        expand ? classes.isExpandSearch : classes.textSearch
                      }
                    >
                      {/* <ClickAwayListener onClickAway={handleClickAwaySearch}> */}
                      <TextField
                        inputRef={textFieldRef}
                        withPadding={true}
                        medium
                        secondary
                        placeholder="Search..."
                        value={searchValue}
                        onClick={() => {
                          if (textFieldRef.current) {
                            textFieldRef.current.focus();
                          }
                          setExpand(true);
                        }}
                        onChange={(e) => {
                          setSearchValue(e?.target?.value);
                          handleSearch(e?.target?.value);
                        }}
                        InputProps={{
                          endAdornment: (
                            <>
                              <InputAdornment
                                position="end"
                                onClick={() => {
                                  if (textFieldRef.current) {
                                    textFieldRef.current.focus();
                                  }
                                  setExpand(true);
                                }}
                              >
                                <PrimaryIcon
                                  width="20px"
                                  icon={SearchIcon}
                                  onClick={() => {
                                    if (textFieldRef.current) {
                                      textFieldRef.current.focus();
                                    }
                                    setExpand(true);
                                  }}
                                />
                              </InputAdornment>
                            </>
                          ),
                        }}
                      />
                      {/* </ClickAwayListener> */}
                    </Box>
                    {/* Other Buttons */}
                    {width <= 768 && width >= 680 && (
                      <Grid className={classes.resHeaderButtons}>
                        <HtmlTooltipMain
                          title="Delete All Patients"
                          className="hoverAlign"
                        >
                          <IconButton
                            className={classes.rsButtonAddIcon}
                            variant="contained"
                            disabled={selected?.length > 0 ? true : false}
                            onClick={() => {
                              setDeleteAll(true);
                            }}
                          >
                            <PrimaryIcon
                              width="20px"
                              icon={DeleteIcon}
                              cursor="pointer"
                            />
                          </IconButton>
                        </HtmlTooltipMain>

                        <HtmlTooltipMain
                          title="How To Import"
                          className="hoverAlign"
                          open={openTooltip}
                          // onOpen={() => setOpenTooltip(true)}
                          // onClose={() => setOpenTooltip(false)}
                        >
                          <Box className={classes.rsHowTo}>
                            <IconButton
                              className={classes.rsButtonHowtoIcon}
                              variant="contained"
                              // disabled={selected?.length > 0 ? true : false}
                              // onClick={() => {
                              // setDeleteAll(true);
                              // }}
                              onClick={() => {
                                // setOpenSelect(!openSelect);
                              }}
                            >
                              <PrimaryIcon
                                width="20px"
                                icon={ContactSupportIcon}
                                cursor="pointer"
                              />
                            </IconButton>
                            <Select
                              open={openSelect}
                              onOpen={() => {
                                setOpenSelect(true);
                                setOpenTooltip(false);
                              }}
                              onClose={() => {
                                setOpenSelect(false);
                                setOpenTooltip(false);
                              }}
                              onMouseLeave={() => {
                                setOpenTooltip(false);
                                setIsMouseOverButton(false);
                              }}
                              onMouseEnter={() => {
                                setOpenTooltip(true);
                                setIsMouseOverButton(true);
                              }}
                              className={
                                selected?.length > 0
                                  ? classes.rsSelectMenulist
                                  : classes.rsSelectMenulistProject
                              }
                              hideBackdrop={true}
                              MenuProps={{
                                disableScrollLock: true,
                                BackdropProps: {
                                  className: classes.customBackdrop,
                                },
                                PaperProps: {
                                  style: {
                                    padding: "0px",
                                    // maxHeight: ITEM_HEIGHT * 4.5,
                                    // width: "32ch",
                                    marginTop: "10px",
                                  },
                                },
                              }}
                            >
                              {importType.map((name) => (
                                <MenuItem
                                  hideBackdrop={true}
                                  key={name.value}
                                  value={name.label}
                                  onClick={(e, value) => {
                                    setDocLink(name?.link);
                                    setImportTypeDiloag(true);
                                  }}
                                >
                                  {name?.label}
                                </MenuItem>
                              ))}
                              <Box
                                className={classes.MenuListDownload}
                                // onClick={() => {
                                //   downloadPDF();
                                // }}
                              >
                                <Button
                                  // className={classes.MenuListDownload}
                                  variant="outlined"
                                  onClick={() => {
                                    downloadPDFProscript();
                                  }}
                                >
                                  Download Demo Proscript
                                </Button>
                              </Box>
                              <Box
                                className={classes.MenuListDownload}
                                // onClick={() => {
                                //   downloadPDF();
                                // }}
                              >
                                <Button
                                  // className={classes.MenuListDownload}
                                  variant="outlined"
                                  onClick={() => {
                                    downloadPDFRX();
                                  }}
                                >
                                  Download Demo RxWeb
                                </Button>
                              </Box>
                              <Box
                                className={classes.MenuListDownload}
                                // onClick={() => {
                                //   downloadPDF();
                                // }}
                              >
                                <Button
                                  // className={classes.MenuListDownload}
                                  variant="outlined"
                                  onClick={() => {
                                    downloadPDFTitan();
                                  }}
                                >
                                  Download Demo Titan
                                </Button>
                              </Box>
                              <Box
                                className={classes.MenuListDownload}
                                // onClick={() => {
                                //   downloadPDF();
                                // }}
                              >
                                <Button
                                  // className={classes.MenuListDownload}
                                  variant="outlined"
                                  onClick={() => {
                                    downloadPDFMPS();
                                  }}
                                >
                                  Download Demo MPS
                                </Button>
                              </Box>
                            </Select>
                          </Box>
                        </HtmlTooltipMain>

                        <HtmlTooltipMain
                          title=" Import Patient"
                          className="hoverAlign"
                        >
                          <IconButton
                            className={classes.rsButtonOrderIcon}
                            // className={classes.importBtn}
                            variant="outlined"
                            // className="btn_green"
                            onClick={() => {
                              setOpenImportCsvPopup(true);
                              // navigate(`/patients?actionType=import-patient`);
                            }}
                          >
                            <PrimaryIcon
                              color="white !important"
                              icon={ImportIcon}
                              // color="primary"
                              width="16px"
                              height="16px"
                            />
                          </IconButton>
                        </HtmlTooltipMain>

                        {selected?.length > 0 && (
                          <HtmlTooltip
                            title={
                              selected?.length === 0
                                ? "Select one or more patients to add repeat orders"
                                : selected?.length > 100
                                ? "Select less then 100 patients to add repeat orders"
                                : ""
                            }
                          >
                            <Box className={classes.buttonAddorder}>
                              {" "}
                              <HtmlTooltip title={"Add Repeat Orders"}>
                                <IconButton
                                  // variant="outlined"
                                  className={classes.repeatordermultiple}
                                  disabled={
                                    selected?.length === 0 ||
                                    patientList?.data?.list?.length === 0
                                  }
                                  onClick={() => {
                                    if (
                                      selected?.length > 0 &&
                                      selected?.length <= 100
                                    ) {
                                      setMultipleOrderDialog(true);
                                    } else if (selected?.length > 100) {
                                      setMaxSelectDialog(true);
                                    }
                                  }}
                                >
                                  <PrimaryIcon
                                    width="20px"
                                    icon={RepeatorderIcon}
                                    cursor="pointer"
                                    color="#7bbd4b"
                                  />

                                  {/* Add Repeat Orders */}
                                  <span>
                                    {selected?.length > 0
                                      ? `${selected?.length}`
                                      : ""}
                                  </span>
                                </IconButton>
                              </HtmlTooltip>
                            </Box>
                          </HtmlTooltip>
                        )}
                      </Grid>
                    )}
                    <Box
                      className="ColumnMain"
                      onClick={(e) => {
                        setColumnsPopperAnchorEl(e.currentTarget);
                        if (
                          ["pharmacist_staff", "pharmacy"].indexOf(
                            showDataBasedOnRole
                          ) !== -1
                        ) {
                          setPatientActionType("patientPharmacyDetails");
                        } else {
                          setPatientActionType("patientDetails");
                        }
                        setOpenTableColumn(true);
                      }}
                    >
                      <HtmlTooltip title="Columns">
                        <Box>
                          <Button
                            className="ColumnBtn"
                            // onClick={() => {
                            //   if (
                            //     ["pharmacist_staff", "pharmacy"].indexOf(
                            //       showDataBasedOnRole
                            //     ) !== -1
                            //   ) {
                            //     setPatientActionType("patientPharmacyDetails");
                            //   } else {
                            //     setPatientActionType("patientDetails");
                            //   }
                            //   setOpenTableColumn(true);
                            // }}
                          >
                            <PrimaryIcon
                              color="black"
                              width="20px"
                              icon={ViewWeekIcon}
                              cursor="pointer"
                            />
                            Columns
                            <PrimaryIcon
                              color="black"
                              width="30px"
                              icon={ArrowDropDownIcon}
                              cursor="pointer"
                            />
                          </Button>
                        </Box>
                      </HtmlTooltip>
                    </Box>
                  </Grid>
                </Grid>
              )}

              {/* {width < 430 && (
                <Grid className={classes.filterHeadMobile}>
                  <HtmlTooltipMain title="" className="hoverAlign">
                    <Button
                      className={classes.rsCreateButton}
                      variant="contained"
                      startIcon={
                        <PrimaryIcon
                          icon={AddIcon}
                          color="white"
                          width="16px"
                          height="16px"
                        />
                      }
                      onClick={() => {
                        navigate("/patients?actionType=create");
                        let payload = {
                          offset: 0,
                          limit: patientListRecordLimit,
                          order_by: columnSortingOrder.orderBy,
                          sort_by: columnSortingOrder.sortBy.toUpperCase(),
                        };

                        if (selectedHeaderPharmacyId !== "all") {
                          payload.pharmacy_id = [selectedHeaderPharmacyId];
                        }
                        getPatientListAction(getClearObject(payload));
                      }}
                    >
                      Create Patient
                    </Button>
                  </HtmlTooltipMain>
                  <Grid>
                    <Box
                      className={
                        expand ? classes.isExpandSearch : classes.textSearch
                      }
                    >
                      <TextField
                        inputRef={textFieldRef}
                        withPadding={true}
                        medium
                        secondary
                        placeholder="Search..."
                        value={searchValue}
                        onClick={() => {
                          if (textFieldRef.current) {
                            textFieldRef.current.focus();
                          }
                          setExpand(true);
                        }}
                        onChange={(e) => {
                          setSearchValue(e?.target?.value);
                          handleSearch(e?.target?.value);
                        }}
                        InputProps={{
                          endAdornment: (
                            <>
                              <InputAdornment
                                position="end"
                                onClick={() => {
                                  if (textFieldRef.current) {
                                    textFieldRef.current.focus();
                                  }
                                  setExpand(true);
                                }}
                              >
                                <PrimaryIcon
                                  width="20px"
                                  icon={SearchIcon}
                                  onClick={() => {
                                    if (textFieldRef.current) {
                                      textFieldRef.current.focus();
                                    }
                                    setExpand(true);
                                  }}
                                />
                              </InputAdornment>
                            </>
                          ),
                        }}
                      />
                    </Box>

                    {selected?.length > 0 && (
                      <HtmlTooltip
                        title={
                          selected?.length === 0
                            ? "Select one or more patients to add repeat orders"
                            : selected?.length > 100
                            ? "Select less then 100 patients to add repeat orders"
                            : ""
                        }
                      >
                        <Box className={classes.buttonAddorder}>
                          {" "}
                          <HtmlTooltip title={"Add Repeat Orders"}>
                            <IconButton
                              className={classes.repeatordermultiple}
                              disabled={
                                selected?.length === 0 ||
                                patientList?.data?.list?.length === 0
                              }
                              onClick={() => {
                                if (
                                  selected?.length > 0 &&
                                  selected?.length <= 100
                                ) {
                                  setMultipleOrderDialog(true);
                                } else if (selected?.length > 100) {
                                  setMaxSelectDialog(true);
                                }
                              }}
                            >
                              <PrimaryIcon
                                width="20px"
                                icon={RepeatorderIcon}
                                cursor="pointer"
                                color="#7bbd4b"
                              />

                              <span>
                                {selected?.length > 0
                                  ? `${selected?.length}`
                                  : ""}
                              </span>
                            </IconButton>
                          </HtmlTooltip>
                        </Box>
                      </HtmlTooltip>
                    )}
                    <HtmlTooltipMain
                      title="Delete All Patients"
                      className="hoverAlign"
                    >
                      <IconButton
                        className={classes.rsButtonAddIcon}
                        variant="contained"
                        disabled={selected?.length > 0 ? true : false}
                        onClick={() => {
                          setDeleteAll(true);
                        }}
                      >
                        <PrimaryIcon
                          width="20px"
                          icon={DeleteIcon}
                          cursor="pointer"
                        />
                      </IconButton>
                    </HtmlTooltipMain>
                  </Grid>
                  <Grid>
                    <HtmlTooltipMain
                      title="How To Import"
                      className="hoverAlign"
                    >
                      <Box className={classes.rsHowTo}>
                        <IconButton
                          className={classes.rsButtonHowtoIcon}
                          variant="contained"
                          onClick={() => {
                          }}
                        >
                          <PrimaryIcon
                            width="20px"
                            icon={ContactSupportIcon}
                            cursor="pointer"
                          />
                        </IconButton>

                        <Select
                          className={
                            selected?.length > 0
                              ? classes.rsSelectMenulist
                              : classes.rsSelectMenulistProject
                          }
                          MenuProps={{
                            PaperProps: {
                              style: {
                                padding: "0px",
                                width: "32ch",
                                marginTop: "20px",
                              },
                            },
                          }}
                        >
                          {importType.map((name) => (
                            <MenuItem
                              key={name.value}
                              value={name.label}
                              onClick={(e, value) => {
                                setDocLink(name?.link);
                                setImportTypeDiloag(true);
                              }}
                            >
                              {name?.label}
                            </MenuItem>
                          ))}
                          <Box
                            className={classes.MenuListDownload}
                          >
                            <Button
                              variant="outlined"
                              onClick={() => {
                                downloadPDFProscript();
                              }}
                            >
                              Download Demo Proscript
                            </Button>
                          </Box>
                          <Box
                            className={classes.MenuListDownload}
                          >
                            <Button
                              variant="outlined"
                              onClick={() => {
                                downloadPDFRX();
                              }}
                            >
                              Download Demo RxWeb
                            </Button>
                          </Box>
                          <Box
                            className={classes.MenuListDownload}
                          >
                            <Button
                              variant="outlined"
                              onClick={() => {
                                downloadPDFTitan();
                              }}
                            >
                              Download Demo Titan
                            </Button>
                          </Box>
                          <Box
                            className={classes.MenuListDownload}
                          >
                            <Button
                              variant="outlined"
                              onClick={() => {
                                downloadPDFMPS();
                              }}
                            >
                              Download Demo MPS
                            </Button>
                          </Box>
                        </Select>
                      </Box>
                    </HtmlTooltipMain>
                    <HtmlTooltipMain
                      title=" Import Patient"
                      className="hoverAlign"
                    >
                      <IconButton
                        className={classes.rsButtonOrderIcon}
                        variant="outlined"
                        onClick={() => {
                          setOpenImportCsvPopup(true);
                        }}
                      >
                        <PrimaryIcon
                          color="white !important"
                          icon={ImportIcon}
                          width="16px"
                          height="16px"
                        />
                      </IconButton>
                    </HtmlTooltipMain>

                    <Box className="ColumnMain">
                      <HtmlTooltip title="Columns">
                        <Box>
                          <Button
                            className="ColumnBtn"
                            onClick={() => {
                              if (
                                ["pharmacist_staff", "pharmacy"].indexOf(
                                  showDataBasedOnRole
                                ) !== -1
                              ) {
                                setPatientActionType("patientPharmacyDetails");
                              } else {
                                setPatientActionType("patientDetails");
                              }
                              setOpenTableColumn(true);
                            }}
                          >
                            <PrimaryIcon
                              color="black"
                              width="20px"
                              icon={ViewWeekIcon}
                              cursor="pointer"
                            />
                            Columns
                            <PrimaryIcon
                              color="black"
                              width="30px"
                              icon={ArrowDropDownIcon}
                              cursor="pointer"
                            />
                          </Button>
                        </Box>
                      </HtmlTooltip>
                    </Box>
                  </Grid>
                </Grid>
              )} */}
            </Grid>
          </Grid>
          {/* <Box className={classes.rsSettingMain}>
            <HtmlTooltip title="Settings">
              <Box className={classes.rsSetting}>
                <PrimaryIcon
                  color="secondary"
                  className={classes.globalSettingIcon}
                  width="20px"
                  icon={SettingIcon}
                  cursor="pointer"
                  onClick={() => {
                    if (
                      ["pharmacist_staff", "pharmacy"].indexOf(
                        showDataBasedOnRole
                      ) !== -1
                    ) {
                      setPatientActionType("patientPharmacyDetails");
                    } else {
                      setPatientActionType("patientDetails");
                    }
                    setOpenTableColumn(true);
                  }}
                />
              </Box>
            </HtmlTooltip>
          </Box> */}
        </Grid>
        <Box className={classes.rsGrid}>
          <Grid
            className={clsx(
              classes.rsTable,
              width <= 1200 ? classes.managePageHMob : classes.managePageH
            )}
          >
            <TableContainer>
              <Table stickyHeader>
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    {/* <TableCell>
                      <FormControlLabel
                        className={classes.labelWhiteSpaceNW}
                        checked={
                          patientList?.data?.list?.length > 0 &&
                          selected?.length === patientList?.data?.list?.length
                        }
                        onChange={handleChangeAction}
                        control={<Checkbox color="primary" />}
                      />
                    </TableCell> */}
                    {Object.keys(tableColumns).map((headCell) => (
                      <>
                        {tableColumns[headCell].show && (
                          <>
                            {tableColumns[headCell].sortable === true ? (
                              <TableCell
                                key={tableColumns[headCell].id}
                                align="center"
                                padding={
                                  tableColumns[headCell].disablePadding
                                    ? "none"
                                    : "normal"
                                }
                              >
                                <Box className={classes.rsTableCellHeader}>
                                  {tableColumns[headCell].id == "name" && (
                                    <FormControlLabel
                                      className={classes.labelWhiteSpaceNW}
                                      checked={
                                        patientList?.data?.list?.length > 0 &&
                                        selected?.length ===
                                          patientList?.data?.list?.length
                                      }
                                      onChange={handleChangeAction}
                                      control={<Checkbox color="primary" />}
                                    />
                                  )}

                                  <TableSortLabel
                                    sx={{
                                      "&.MuiTableSortLabel-root": {
                                        color: "white",
                                      },
                                      "& .MuiTableSortLabel-icon": {
                                        color:
                                          columnSortingOrder.orderBy ===
                                          tableColumns[headCell].id
                                            ? "#525252 !important"
                                            : "#C5C5C5 !important",
                                        "&.MuiTableSortLabel-iconDirectionDesc":
                                          {
                                            color: "#525252 !important",
                                          },
                                        "& .MuiTableSortLabel-iconDirectionAsc":
                                          {
                                            color:
                                              columnSortingOrder.orderBy ===
                                              tableColumns[headCell].id
                                                ? "#525252 !important"
                                                : "#C5C5C5 !important",
                                          },
                                      },
                                    }}
                                    className="tableSort"
                                    direction={
                                      columnSortingOrder.orderBy ===
                                      tableColumns[headCell].id
                                        ? columnSortingOrder.sortBy
                                        : defaultColumnOrderBy
                                    }
                                    onClick={(e) => {
                                      setColumnSortingOrder({
                                        orderBy: tableColumns[headCell].id,
                                        sortBy:
                                          (columnSortingOrder.orderBy ===
                                          tableColumns[headCell].id
                                            ? columnSortingOrder.sortBy
                                            : defaultColumnOrderBy) === "desc"
                                            ? "asc"
                                            : "desc",
                                      });
                                    }}
                                  >
                                    {tableColumns[headCell].label}
                                  </TableSortLabel>
                                  {tableColumns[headCell].icons === true && (
                                    <Box
                                      className={classes.rsIconFilterDispense}
                                    >
                                      <Box className={classes.rsiconBtn}>
                                        <FilterListIcon
                                          className={classes.rsCursor}
                                          onClick={(e) =>
                                            handleIconFilterChange(e)
                                          }
                                        />
                                        {(complianceStatus === true ||
                                          patientTypeStatus?.length > 0 ||
                                          instalmentTypeStatus?.length > 0 ||
                                          patientFilterTypeStatus?.length >
                                            0) && (
                                          <Box
                                            className={classes.rsActiveIconBtn}
                                          ></Box>
                                        )}
                                      </Box>
                                      <Box>
                                        <Popper
                                          open={checked}
                                          anchorEl={popperAnchorEl}
                                          placement={"bottom"}
                                          className={classes.rsPopperPage}
                                        >
                                          <ClickAwayListener
                                            onClickAway={handleClickAway}
                                          >
                                            <Collapse in={checked}>
                                              <ul
                                                className={
                                                  classes.rsWaringFilterlistview
                                                }
                                              >
                                                {/* <li
                                                  className={classes.rsCursor}
                                                  onClick={(e) => {
                                                    setComplianceStatus(
                                                      !complianceStatus
                                                    );
                                                  }}
                                                >
                                                  <Chips
                                                    label="Compliance"
                                                    color={
                                                      complianceStatus
                                                        ? "rgba(137, 156, 18, 0.6) "
                                                        : ""
                                                    }
                                                    variant={
                                                      complianceStatus
                                                        ? "filled"
                                                        : "outlined"
                                                    }
                                                    borderColorChip={
                                                      complianceStatus
                                                        ? ""
                                                        : "rgba(137, 156, 18, 1)"
                                                    }
                                                    textColor={
                                                      complianceStatus
                                                        ? "white"
                                                        : "rgba(137, 156, 18, 1)"
                                                    }
                                                    border={
                                                      complianceStatus
                                                        ? ""
                                                        : "3"
                                                    }
                                                    width="100px"
                                                  />
                                                </li> */}

                                                {/* <li
                                                  className={classes.rsCursor}
                                                  onClick={() =>
                                                    handleType("patient")
                                                  }
                                                >
                                                  <Box
                                                    className={
                                                      classes.rsListAlignment
                                                    }
                                                  >
                                                    <Box>
                                                      Patient Type
                                                      {patientTypeStatus?.length >
                                                        0 && (
                                                        <Box
                                                          className={
                                                            classes.rsActiveBtn
                                                          }
                                                        ></Box>
                                                      )}
                                                    </Box>
                                                    <PrimaryIcon
                                                      width="20px"
                                                      height="20px"
                                                      icon={
                                                        patientTypeOpen
                                                          ? KeyboardArrowUpOutlinedIcon
                                                          : KeyboardArrowDownOutlinedIcon
                                                      }
                                                    />
                                                  </Box>
                                                </li> */}
                                                {/* <Collapse in={patientTypeOpen}>
                                                  <ul
                                                    className={
                                                      classes.rsWaringFilterlistview
                                                    }
                                                  >
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "collection",
                                                          "patient"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Collection"
                                                        color={
                                                          patientTypeStatus.includes(
                                                            "collection"
                                                          )
                                                            ? "rgba(123, 192, 68,0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          patientTypeStatus.includes(
                                                            "collection"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          patientTypeStatus.includes(
                                                            "collection"
                                                          )
                                                            ? ""
                                                            : "rgba(123, 192, 68,1)"
                                                        }
                                                        textColor={
                                                          patientTypeStatus.includes(
                                                            "collection"
                                                          )
                                                            ? "white"
                                                            : "rgba(123, 192, 68,1)"
                                                        }
                                                        border={
                                                          patientTypeStatus.includes(
                                                            "collection"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>

                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "delivery",
                                                          "patient"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Delivery"
                                                        color={
                                                          patientTypeStatus.includes(
                                                            "delivery"
                                                          )
                                                            ? "rgba(218, 120, 32, 0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          patientTypeStatus.includes(
                                                            "delivery"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          patientTypeStatus.includes(
                                                            "delivery"
                                                          )
                                                            ? ""
                                                            : "rgba(218, 120, 32, 1)"
                                                        }
                                                        textColor={
                                                          patientTypeStatus.includes(
                                                            "delivery"
                                                          )
                                                            ? "white"
                                                            : "rgba(218, 120, 32, 1)"
                                                        }
                                                        border={
                                                          patientTypeStatus.includes(
                                                            "delivery"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                  </ul>
                                                  <Divider
                                                    className={
                                                      classes.rsDivider
                                                    }
                                                  />
                                                </Collapse> */}
                                                {/* <li
                                                  className={classes.rsCursor}
                                                  onClick={() =>
                                                    handleType("dispense")
                                                  }
                                                >
                                                  <Box
                                                    className={
                                                      classes.rsListAlignment
                                                    }
                                                  >
                                                    <Box>
                                                      Dispense
                                                      {instalmentTypeStatus?.length >
                                                        0 && (
                                                        <Box
                                                          className={
                                                            classes.rsActiveBtn
                                                          }
                                                        ></Box>
                                                      )}
                                                    </Box>
                                                    <PrimaryIcon
                                                      width="20px"
                                                      height="20px"
                                                      icon={
                                                        dispenseTypeOpen
                                                          ? KeyboardArrowUpOutlinedIcon
                                                          : KeyboardArrowDownOutlinedIcon
                                                      }
                                                    />
                                                  </Box>
                                                </li> */}
                                                {/* <Collapse in={dispenseTypeOpen}>
                                                  <ul
                                                    className={
                                                      classes.rsWaringFilterlistview
                                                    }
                                                  >
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "daily",
                                                          "dispense"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Daily"
                                                        color={
                                                          instalmentTypeStatus.includes(
                                                            "daily"
                                                          ) == true
                                                            ? "rgba(56, 91, 177, 0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          instalmentTypeStatus.includes(
                                                            "daily"
                                                          ) == true
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          instalmentTypeStatus.includes(
                                                            "daily"
                                                          ) == true
                                                            ? ""
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        textColor={
                                                          instalmentTypeStatus.includes(
                                                            "daily"
                                                          ) == true
                                                            ? "white"
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        border={
                                                          instalmentTypeStatus.includes(
                                                            "daily"
                                                          ) == true
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "weekly",
                                                          "dispense"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Weekly"
                                                        color={
                                                          instalmentTypeStatus.includes(
                                                            "weekly"
                                                          )
                                                            ? "rgba(56, 91, 177, 0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          instalmentTypeStatus.includes(
                                                            "weekly"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          instalmentTypeStatus.includes(
                                                            "weekly"
                                                          )
                                                            ? ""
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        textColor={
                                                          instalmentTypeStatus.includes(
                                                            "weekly"
                                                          )
                                                            ? "white"
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        border={
                                                          instalmentTypeStatus.includes(
                                                            "weekly"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "twice_weekly",
                                                          "dispense"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Twice a Week"
                                                        color={
                                                          instalmentTypeStatus.includes(
                                                            "twice_weekly"
                                                          )
                                                            ? "rgba(56, 91, 177, 0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          instalmentTypeStatus.includes(
                                                            "twice_weekly"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          instalmentTypeStatus.includes(
                                                            "twice_weekly"
                                                          )
                                                            ? ""
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        textColor={
                                                          instalmentTypeStatus.includes(
                                                            "twice_weekly"
                                                          )
                                                            ? "white"
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        border={
                                                          instalmentTypeStatus.includes(
                                                            "twice_weekly"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "three_times_a_week",
                                                          "dispense"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Thrice a Week"
                                                        color={
                                                          instalmentTypeStatus.includes(
                                                            "three_times_a_week"
                                                          )
                                                            ? "rgba(56, 91, 177, 0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          instalmentTypeStatus.includes(
                                                            "three_times_a_week"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          instalmentTypeStatus.includes(
                                                            "three_times_a_week"
                                                          )
                                                            ? ""
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        textColor={
                                                          instalmentTypeStatus.includes(
                                                            "three_times_a_week"
                                                          )
                                                            ? "white"
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        border={
                                                          instalmentTypeStatus.includes(
                                                            "three_times_a_week"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "fortnight",
                                                          "dispense"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Fortnightly"
                                                        color={
                                                          instalmentTypeStatus.includes(
                                                            "fortnight"
                                                          )
                                                            ? "rgba(56, 91, 177, 0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          instalmentTypeStatus.includes(
                                                            "fortnight"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          instalmentTypeStatus.includes(
                                                            "fortnight"
                                                          )
                                                            ? ""
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        textColor={
                                                          instalmentTypeStatus.includes(
                                                            "fortnight"
                                                          )
                                                            ? "white"
                                                            : "rgba(56, 91, 177, 1)"
                                                        }
                                                        border={
                                                          instalmentTypeStatus.includes(
                                                            "fortnight"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                  </ul>
                                                  <Divider
                                                    className={
                                                      classes.rsDivider
                                                    }
                                                  />
                                                </Collapse> */}
                                                <li
                                                  className={classes.rsCursor}
                                                  onClick={() =>
                                                    handleType("status")
                                                  }
                                                >
                                                  <Box
                                                    className={
                                                      classes.rsListAlignment
                                                    }
                                                  >
                                                    <Box>
                                                      Status
                                                      {patientFilterTypeStatus?.length >
                                                        0 && (
                                                        <Box
                                                          className={
                                                            classes.rsActiveBtn
                                                          }
                                                        ></Box>
                                                      )}
                                                    </Box>
                                                    <PrimaryIcon
                                                      width="20px"
                                                      height="20px"
                                                      icon={
                                                        statusTypeOpen
                                                          ? KeyboardArrowUpOutlinedIcon
                                                          : KeyboardArrowDownOutlinedIcon
                                                      }
                                                    />
                                                  </Box>
                                                </li>
                                                <Collapse in={statusTypeOpen}>
                                                  <ul
                                                    className={
                                                      classes.rsWaringFilterlistview
                                                    }
                                                  >
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "active",
                                                          "status"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Active"
                                                        color={
                                                          patientFilterTypeStatus.includes(
                                                            "active"
                                                          )
                                                            ? "rgba(28, 176, 68,0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          patientFilterTypeStatus.includes(
                                                            "active"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          patientFilterTypeStatus.includes(
                                                            "active"
                                                          )
                                                            ? ""
                                                            : "rgba(28, 176, 68,1)"
                                                        }
                                                        textColor={
                                                          patientFilterTypeStatus.includes(
                                                            "active"
                                                          )
                                                            ? "white"
                                                            : "rgba(28, 176, 68,1)"
                                                        }
                                                        border={
                                                          patientFilterTypeStatus.includes(
                                                            "active"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "in_hospital",
                                                          "status"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="In Hospital"
                                                        color={
                                                          patientFilterTypeStatus.includes(
                                                            "in_hospital"
                                                          )
                                                            ? "rgba(210, 162, 68,0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          patientFilterTypeStatus.includes(
                                                            "in_hospital"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          patientFilterTypeStatus.includes(
                                                            "in_hospital"
                                                          )
                                                            ? ""
                                                            : "rgba(210, 162, 68,1)"
                                                        }
                                                        textColor={
                                                          patientFilterTypeStatus.includes(
                                                            "in_hospital"
                                                          )
                                                            ? "white"
                                                            : "rgba(210, 162, 68,1)"
                                                        }
                                                        border={
                                                          patientFilterTypeStatus.includes(
                                                            "in_hospital"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "absent",
                                                          "status"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Absent"
                                                        color={
                                                          patientFilterTypeStatus.includes(
                                                            "absent"
                                                          )
                                                            ? "rgba(107, 107, 107,0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          patientFilterTypeStatus.includes(
                                                            "absent"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          patientFilterTypeStatus.includes(
                                                            "absent"
                                                          )
                                                            ? ""
                                                            : "rgba(107, 107, 107,1)"
                                                        }
                                                        textColor={
                                                          patientFilterTypeStatus.includes(
                                                            "absent"
                                                          )
                                                            ? "white"
                                                            : "rgba(107, 107, 107,1)"
                                                        }
                                                        border={
                                                          patientFilterTypeStatus.includes(
                                                            "absent"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                    <li
                                                      className={
                                                        classes.rsCursor
                                                      }
                                                      onClick={(e) => {
                                                        manageDispenseFilter(
                                                          "deceased",
                                                          "status"
                                                        );
                                                      }}
                                                    >
                                                      <Chips
                                                        label="Deceased"
                                                        color={
                                                          patientFilterTypeStatus.includes(
                                                            "deceased"
                                                          )
                                                            ? "rgba(255, 0, 0,0.6) "
                                                            : ""
                                                        }
                                                        variant={
                                                          patientFilterTypeStatus.includes(
                                                            "deceased"
                                                          )
                                                            ? "filled"
                                                            : "outlined"
                                                        }
                                                        borderColorChip={
                                                          patientFilterTypeStatus.includes(
                                                            "deceased"
                                                          )
                                                            ? ""
                                                            : "rgba(255, 0, 0,1)"
                                                        }
                                                        textColor={
                                                          patientFilterTypeStatus.includes(
                                                            "deceased"
                                                          )
                                                            ? "white"
                                                            : "rgba(255, 0, 0,1)"
                                                        }
                                                        border={
                                                          patientFilterTypeStatus.includes(
                                                            "deceased"
                                                          )
                                                            ? ""
                                                            : "3"
                                                        }
                                                        width="100px"
                                                      />
                                                    </li>
                                                  </ul>
                                                  <Divider
                                                    className={
                                                      classes.rsDivider
                                                    }
                                                  />
                                                </Collapse>
                                              </ul>
                                            </Collapse>
                                          </ClickAwayListener>
                                        </Popper>
                                      </Box>
                                    </Box>
                                  )}
                                </Box>
                              </TableCell>
                            ) : (
                              <TableCell>
                                {tableColumns[headCell].label}
                              </TableCell>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody className={classes.tableBody}>
                  {patientList?.loading ? (
                    <TableCellLoader
                      cells={
                        showLoaderValue.filter(({ show }) => show === true)
                          .length
                      }
                    />
                  ) : patientList?.data?.list?.length > 0 ? (
                    patientList?.data?.list
                      ?.sort((a, b) => {
                        const isSelecteda = (id) =>
                          selected?.indexOf(id) !== -1;
                        const isItemSelecteda = isSelecteda(a);
                        const isSelectedb = (id) =>
                          selected?.indexOf(id) !== -1;
                        const isItemSelectedb = isSelectedb(b);
                        if (isItemSelecteda && !isItemSelectedb) {
                          return -1; // a should come before b because a is selected and b is not
                        } else if (!isItemSelecteda && isItemSelectedb) {
                          return 1;
                        }
                      })
                      ?.map((item, i) => {
                        const isSelected = (id) => selected?.indexOf(id) != -1;
                        const isItemSelected = selected?.some(
                          (selectedItem) => selectedItem?.id === item?.id
                        );
                        const labelId = `enhanced-table-checkbox-${i}`;
                        return (
                          <PatientTable
                            i={i}
                            item={item}
                            setShowPatientNoteList={setShowPatientNoteList}
                            setDeletePatient={setDeletePatient}
                            setOpenPatientNoteList={setOpenPatientNoteList}
                            setPatientDeleteId={setPatientDeleteId}
                            filteredPatientId={filteredPatientId}
                            setFilteredPatientId={setFilteredPatientId}
                            setPatientStatus={setPatientStatus}
                            setOpenPatientHistory={setOpenPatientHistory}
                            setPatientHistory={setPatientHistory}
                            patientStatus={patientStatus}
                            patientDetailsId={patientDetailsId}
                            setPatientDetailsId={setPatientDetailsId}
                            statusManage={statusManage}
                            setStatusManage={setStatusManage}
                            statusApi={statusApi}
                            setStatusApi={setStatusApi}
                            detailsDialog={detailsDialog}
                            setDetailsDialog={setDetailsDialog}
                            patientDetails={patientDetails}
                            setPatientDetails={setPatientDetails}
                            setOrderCount={setOrderCount}
                            setCollectionCount={setCollectionCount}
                            showDataBasedOnRole={showDataBasedOnRole}
                            tableCells={tableColumns}
                            setIsOpenEditDobModel={setIsOpenEditDobModel}
                            setEditDobDate={setEditDobDate}
                            patientDetailOpen={patientDetailOpen}
                            setPatientDetailOpen={setPatientDetailOpen}
                            patientId={patientId}
                            setPatientId={setPatientId}
                            isItemSelected={isItemSelected}
                            handleClickTickAction={handleClickTickAction}
                            labelId={labelId}
                          />
                        );
                      })
                  ) : (
                    <TableEmptyState />
                  )}
                  {patientList?.data?.list?.length !=
                    patientList?.data?.filterd_record && (
                    <TableLoadMore setRef={setTarget} />
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Box>
      </Grid>
      <NotesDialog
        stickyHeader
        open={openPatientNoteList}
        setOpen={setOpenPatientNoteList}
        title="Patient Notes"
        subTitle="NOTE DETAIL"
        body={showPatientNoteList}
        getPatientNoteListAction={getPatientNoteListAction}
        patientNoteList={patientNoteList}
        createPatientNoteAction={createPatientNoteAction}
        createPatientNoteData={createPatientNoteData}
        updatePatientNoteAction={updatePatientNoteAction}
        updatePatientNoteData={updatePatientNoteData}
        deletePatientNoteAction={deletePatientNoteAction}
        deletePatientNoteData={deletePatientNoteData}
        resetPatientState={resetPatientState}
        getSinglePatientNoteAction={getSinglePatientNoteAction}
        singlePatientNoteData={singlePatientNoteData}
        getOrderListAction={getOrderListAction}
        subscriptionDialog={subscriptionDialog}
        setSubscritionDialog={setSubscritionDialog}
        loginUserDetail={loginUserDetail}
      />
      <EditDobDialog
        open={isOpenEditDobModel}
        setOpen={setIsOpenEditDobModel}
        editData={editDobDate}
        setEditData={setEditDobDate}
        type="patient"
        // orderRecordActionType={orderRecordActionType}
        getList={getList}
        subscriptionDialog={subscriptionDialog}
        setSubscritionDialog={setSubscritionDialog}
        loginUserDetail={loginUserDetail}
      />
      <ConfirmationDialog
        open={deletePatient}
        setOpen={setDeletePatient}
        title="Are you sure?"
        body="You wan't be able to undo this patient!"
        subTitle={`${
          orderCount > 0
            ? `This patient cannot be deleted as it is already assigned to ${orderCount} ${
                orderCount > 1 ? "repeat order" : "repeat order"
              }.`
            : collectionCount > 0
            ? `This patient cannot be deleted as it is already assigned to ${collectionCount} ${
                collectionCount > 1 ? "collection" : "collection"
              }.`
            : ""
        }`}
        handleSubmit={handleDeletePatient}
        actionBtnTitle="Yes Delete It!!"
        loading={deletePatientData?.loading}
      />
      <PatientHistoryDialog
        stickyHeader
        open={openPatientHistory}
        setOpen={setOpenPatientHistory}
        patientHistory={patientHistory}
        title="Medication History"
        getPatientHistoryAction={getPatientHistoryAction}
        patientMedicationHistoryList={patientMedicationHistoryList}
        handleMediArchive={handleMediArchive}
        archiveMedi={archiveMedi}
        setIsArchiveDetails={setIsArchiveDetails}
        isArchiveDetails={isArchiveDetails}
      />
      <PatientOrderAndMediDialog
        open={openOrderMediDialog}
        setOpen={setOpenOrderMediDialog}
        patientDetailsId={patientDetailsId}
        statusManage={statusManage}
        setStatusManage={setStatusManage}
        statusApi={statusApi}
        setStatusApi={setStatusApi}
        setPatientStatus={setPatientStatus}
      />
      <ConfirmationDialog
        open={multipleOrder}
        setOpen={setMultipleOrder}
        subTitle={`This patient has multiple orders`}
        warning="alert"
      />
      <InfomationDialog
        open={detailsDialog}
        setOpen={setDetailsDialog}
        patientDetails={patientDetails}
        setPatientDetails={setPatientDetails}
        type="patient"
      />
      <TableColumnShowMenu
        open={openTableColumn}
        setOpen={setOpenTableColumn}
        anchorEl={columnsPopperAnchorEl}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        onOrderChange={(newOrder) => setTableColumns(newOrder)}
        tableCells={tableCells}
        patientActionType={patientActionType}
        showDataBasedOnRole={showDataBasedOnRole}
        moduleName={"patient"}
      />
      <PatientDetailDialog
        open={patientDetailOpen}
        setOpen={setPatientDetailOpen}
        patientId={patientId}
        setPatientId={setPatientId}
        getSinglePatientAction={getSinglePatientAction}
        data={singlePatientData}
        getPatientHistoryAction={getPatientHistoryAction}
        patientMedicationHistoryList={patientMedicationHistoryList}
        handleMediArchive={handleMediArchive}
        getList={getList}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
      <MultipleOrderDialog
        open={multipleOrderDialog}
        setOpen={setMultipleOrderDialog}
        selected={selected}
        setSelected={setSelected}
        getList={getList}
      />
      <ConfirmationDialog
        open={deletePatientmultiple}
        setOpen={setDeletePatientmultiple}
        title={"Are you sure?"}
        body={"You wan't be able to undo this!"}
        handleSubmit={handleDeleteMultipleList}
        actionBtnTitle={"Yes Delete It!!"}
      />
      <MultipleDeletePatient
        open={deleteAll}
        setOpen={setDeleteAll}
        title={"Are you sure?"}
        loading={deleteAllPatientData?.loading}
        body={"You wan't be able to undo this!"}
        handleSubmit={handleDeleteAllPatient}
        actionBtnTitle={"Yes, Delete It!!"}
        getPatientAllDeletePatientAction={getPatientAllDeletePatientAction}
        deleteAllPatientData={deleteAllPatientData}
      />
      <ImportCsvPatientDialog
        open={openImportCsvPopup}
        setOpen={setOpenImportCsvPopup}
        getImportCsvListAction={getList}
        // subscriptionDialog={subscriptionDialog}
        // setSubscriptionDialog={setSubscriptionDialog}
        loginUserDetail={loginUserDetail}
      />
      <MaxSelectDialog
        open={maxSelectDialog}
        setOpen={setMaxSelectDialog}
        setMultipleOrderDialog={setMultipleOrderDialog}
      />
      <ImportTypeDialog
        link={docLink}
        open={importTypeDiloag}
        setOpen={setImportTypeDiloag}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  patientList: state.patient.patientList,
  deletePatientData: state.patient.deletePatientData,
  patientNoteList: state.patient.patientNoteList,
  createPatientNoteData: state.patient.createPatientNoteData,
  updatePatientNoteData: state.patient.updatePatientNoteData,
  deletePatientNoteData: state.patient.deletePatientNoteData,
  singlePatientNoteData: state.patient.singlePatientNoteData,
  patientMedicationHistoryList: state.patient.patientMedicationHistoryList,
  singlePatientData: state.patient.singlePatientData,
  archiveMedi: state.patient.archiveMedi,
  deleteMultipleAndSingleCsvData: state.patient.deleteMultipleAndSingleCsvData,
  deleteAllPatientData: state.patient.deleteAllPatientData,
});

const mapDispatchToProps = (dispatch) => ({
  getPharmacyListAction: (payload) =>
    dispatch({ type: START_GET_PHARMACIES_LIST, payload }),
  getPatientListAction: (payload) =>
    dispatch({ type: START_GET_PATIENT_LIST, payload }),
  deletePatientAction: (id) => dispatch({ type: START_DELETE_PATIENT, id }),
  resetPatientState: (key, payload) =>
    dispatch({ type: RESET_PATIENT_STATE, key, payload }),
  getPatientNoteListAction: (payload) =>
    dispatch({ type: START_GET_PATIENT_NOTE_LIST, payload }),
  createPatientNoteAction: (payload) =>
    dispatch({ type: START_CREATE_PATIENT_NOTE, payload }),
  updatePatientNoteAction: (id, payload) =>
    dispatch({ type: START_UPDATE_PATIENT_NOTE, id, payload }),
  deletePatientNoteAction: (id) =>
    dispatch({ type: START_DELETE_PATIENT_NOTE, id }),
  getSinglePatientNoteAction: (id) =>
    dispatch({ type: START_GET_SINGLE_PATIENT_NOTE, id }),
  getPatientHistoryAction: (id, payload) =>
    dispatch({ type: START_GET_PATIENT_MEDICATION_HISTORY_LIST, id, payload }),
  getPatientStatusUpdatAction: (id, payload) =>
    dispatch({ type: START_STATUS_PATIENT_UPDATE, id, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  getOrderListAction: (payload) =>
    dispatch({ type: START_GET_REPEAT_ORDER_LIST, payload }),
  getSinglePatientAction: (id) =>
    dispatch({ type: START_GET_SINGLE_PATIENT, id }),
  getMedicationArchiveAction: (id, payload, historyPayload) =>
    dispatch({ type: START_ARCHIVE_MEDICATION, id, payload, historyPayload }),
  getPatientMultipleDeleteAction: (payload) =>
    dispatch({ type: START_PATIENT_MULTI_DELETE, payload }),
  getPatientAllDeletePatientAction: (payload) =>
    dispatch({ type: START_PATIENT_ALL_DELETE, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientsMain);
